export default{
  "games": [
    {
      "id": 1,
      "url": "/games/animalsCrushMatch3/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": "Animals Crush Match3",
      "datasrc": "/games/animalsCrushMatch3/icons/300x300.jpg",
      "logo": "/games/animalsCrushMatch3/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4,
      "synopsis": "Welcome to the charming world of  \"Animals Crush Match \"! Get ready for a delightful puzzle adventure where you'll match adorable animals and explore captivating levels. In Animals Crush Match, your goal is to match three or more identical animal tiles by swapping them horizontally or vertically. Line up the cute and colorful animal characters such as lions, pandas, elephants, and more to create satisfying combinations and clear the board. Embark on a journey through various enchanting environments, each filled with unique challenges and objectives. From lush jungles to icy Arctic landscapes, discover new levels and unlock hidden surprises as you progress. As you advance, you'll encounter obstacles and special tiles that require strategic thinking to overcome. Utilize powerful boosters and special items to help you clear difficult levels and achieve higher scores.  Let's begin the adventure in Animals Crush Match!"
    },
    {
      "id": 2,
      "url": "/games/basketballKings2022/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": "Basketball Kings2022",
      "datasrc": "/games/basketballKings2022/icons/300x300.jpg",
      "logo": "/games/basketballKings2022/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Get ready to hit the court and showcase your basketball skills in  \"Basketball Kings 2022 \"! Step into the shoes of a professional basketball player and experience the excitement of the game like never before. In Basketball Kings 2022, you'll have the opportunity to compete in thrilling basketball matches against top teams from around the world. Show off your dribbling, shooting, and dunking abilities as you aim for victory and strive to become a basketball legend. Experience realistic gameplay with smooth controls and lifelike animations that capture the intensity and energy of the sport. Perform flashy crossovers, perfect your three-point shots, and unleash powerful dunks that will leave the crowd in awe. Participate in various game modes, including quick matches, tournaments, and challenging leagues."
    },
    {
      "id": 3,
      "url": "/games/blackjackMaster/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": "Blackjack Master",
      "datasrc": "/games/blackjackMaster/icons/300x300.jpg",
      "logo": "/games/blackjackMaster/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "Welcome to the world of high-stakes card games with  \"Blackjack Master \"! Test your skills, strategy, and luck as you aim to beat the dealer and become a Blackjack master. In this classic casino game, your objective is to get a hand value closer to 21 than the dealer's hand without going over. Place your bets, receive two cards, and make decisions to either hit (get another card) or stand (keep your current hand). Carefully analyze the value of your cards and consider the dealer's upcard to determine your moves. Will you play it safe and stay with a lower hand, or take risks by hitting for a chance at a higher total? But be cautious—going over 21 results in a bust, and the dealer wins automatically. Pay attention to the dynamics of the game, use your strategic thinking, and master the art of knowing when to hit or stand. Experience the excitement of playing in realistic casino environments with stunning graphics and authentic sound effects. Customize your gameplay with different table themes and card designs to suit your preferences. Challenge yourself by playing in different game modes, including single-player against the computer or multiplayer where you can compete against friends or other players from around the world. Can you rise through the ranks and dominate the leaderboard? Whether you're a seasoned pro or new to the game, Blackjack Master offers an immersive and thrilling experience that will test your decision-making skills and provide endless entertainment. Take a seat at the table, place your bets, and show off your Blackjack prowess in Blackjack Master!"
    },
    {
      "id": 4,
      "url": "/games/brickCrush2In1/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": "Brick Crush2 In1",
      "datasrc": "/games/brickCrush2In1/icons/300x300.jpg",
      "logo": "/games/brickCrush2In1/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Welcome to  \"Brick Crush 2-in-1 \"! Get ready for a double dose of brick-breaking fun with two captivating game modes in one exciting package. Brick Crush 2-in-1 combines two popular brick-breaking games into a single thrilling experience. Let's explore the two game modes: 1. Classic Mode: In this mode, you'll embark on a nostalgic journey reminiscent of traditional brick-breaking games. Use a paddle at the bottom of the screen to bounce a ball and break through a wall of colorful bricks. Aim carefully, adjust your paddle's position, and strategically angle the ball to eliminate all the bricks. Watch out for power-ups that can enhance your abilities or introduce new challenges. Clear each level, advance to the next set of bricks, and strive for high scores. 2. Endless Mode: If you're looking for non-stop brick-busting action, Endless Mode will keep you engaged. Here, the goal is to survive as long as possible by breaking bricks that continuously descend from the top of the screen. As the difficulty increases, bricks may become faster, larger, or more resistant. Your reflexes and accuracy will be put to the test as you aim to achieve the highest score on the leaderboard. Immerse yourself in vibrant visuals, lively animations, and immersive sound effects that enhance the gameplay experience. Each mode offers its own unique challenges and power-ups, keeping you engaged and entertained for hours. As you progress, collect coins and gems to unlock new paddle designs, balls, and visual themes to customize your playing experience. Experiment with different combinations and find the perfect setup that suits your style. Challenge yourself, compete against friends, or strive to top the global leaderboards in both Classic and Endless Modes. With addictive gameplay, strategic brick-breaking mechanics, and rewarding progression, Brick Crush 2-in-1 is sure to provide hours of entertainment for players of all ages. So, grab your paddle, brace yourself for the bouncing action, and embark on a brick-crushing adventure in Brick Crush 2-in-1!"
    },
    {
      "id": 5,
      "url": "/games/checkersLegend/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": "Checkers Legend",
      "datasrc": "/games/checkersLegend/icons/300x300.jpg",
      "logo": "/games/checkersLegend/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Experience the timeless game of strategy and skill in  \"Checkers Legend \"! Immerse yourself in this classic board game as you compete against opponents from around the world or challenge your friends to a thrilling match. Strategize your moves and aim to capture your opponent's pieces while protecting your own. Plan your jumps, create powerful combos, and outwit your rivals to claim victory on the checkered battlefield. Choose from various gameplay modes, including Classic, Time Attack, and Online Multiplayer. Test your skills against challenging AI opponents or go head-to-head with players worldwide in real-time matches. Can you rise to the top and become a Checkers Legend? Customize your game with different themes, boards, and piece designs to add a personal touch to the experience. Unlock achievements, climb the leaderboards, and showcase your mastery of the game. Whether you're a seasoned player or new to checkers, Checkers Legend offers a captivating and addictive gameplay experience that will keep you coming back for more. Are you ready to make your move and claim the title of Checkers Legend? It's time to show off your strategic brilliance on the checkerboard!"
    },
    {
      "id": 6,
      "url": "/games/chubbyBirds/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": "Chubby Birds",
      "datasrc": "/games/chubbyBirds/icons/300x300.jpg",
      "logo": "/games/chubbyBirds/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Get ready to meet the adorable  \"Chubby Birds \"! These plump and cheerful avian friends need your help to embark on a whimsical adventure through vibrant and challenging environments. Guide the Chubby Birds through a series of engaging levels, each filled with obstacles and puzzles. Tap to make them fly, navigate narrow gaps, and avoid obstacles to reach their destination safely. But be careful! The chubby nature of these birds adds an extra layer of challenge. Their round bodies make precise maneuvers essential. Timing is key as you navigate through tight spaces and collect valuable rewards along the way. Discover a variety of enchanting worlds and unlock new chubby bird characters with unique abilities. Each bird has its own personality and style, adding an extra element of fun and strategy to your gameplay. With its charming visuals, delightful sound effects, and addictive gameplay, Chubby Birds offers a lighthearted and entertaining experience for players of all ages. Can you lead the Chubby Birds to victory and overcome every obstacle in their path? Are you ready to embark on a chubby-filled adventure? It's time to spread those wings and guide the adorable Chubby Birds to success!"
    },
    {
      "id": 7,
      "url": "/games/classicMiniGolf/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": "Classic Mini Golf",
      "datasrc": "/games/classicMiniGolf/icons/300x300.jpg",
      "logo": "/games/classicMiniGolf/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Welcome to  \"Classic MiniGolf \"! Step onto the green and get ready for a delightful and challenging round of miniature golf. In Classic MiniGolf, you'll experience the timeless joy of playing mini-golf in beautifully designed courses. Putt your way through a series of creatively themed holes, each offering unique obstacles, twists, and turns. The objective is simple: Using your club, aim and strike the golf ball with just the right amount of power to navigate the course and sink it into the hole in as few strokes as possible. Study the layout, assess the angles, and plan your shots strategically to avoid hazards and achieve the best score. Immerse yourself in immersive 3D graphics that bring each mini-golf course to life. Enjoy realistic physics simulations that accurately depict the ball's trajectory, roll, and interactions with the environment. From lush gardens to challenging water features, each hole offers a visually captivating and enjoyable experience. Classic MiniGolf provides a variety of game modes to suit your preferences. Take on the classic Championship mode, where you compete against computer opponents or friends in a series of challenging rounds. Aim for the lowest overall score to claim victory. If you prefer a more relaxed experience, try out the Practice mode, where you can hone your skills on individual holes without any pressure. Perfect your technique, experiment with different shots, and become a master of the greens. Challenge yourself by unlocking additional courses as you progress through the game. Each course presents new challenges and exciting gameplay elements, ensuring a fresh and engaging experience as you advance. Invite your friends for multiplayer matches and enjoy friendly competition as you putt your way towards victory. With customizable options and various game settings, you can create your ideal mini-golf experience. So, grab your putter, line up your shots, and prepare to test your skill and precision in the wonderful world of Classic MiniGolf. Sink those birdies, navigate the obstacles, and enjoy the thrill of miniature golfing fun!"
    },
    {
      "id": 8,
      "url": "/games/connectLights/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": "Connect Lights",
      "datasrc": "/games/connectLights/icons/300x300.jpg",
      "logo": "/games/connectLights/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Welcome to  \"Connect Lights \"! Prepare yourself for a challenging and entertaining puzzle game where the goal is to connect all the lights on the board. In Connect Lights, you'll be presented with a grid filled with colorful lights. Your objective is to create a connection between each pair of lights by drawing paths without crossing or overlapping them. The paths must cover the entire grid, ensuring that all lights are connected. To play, simply tap on a light source and then select another light to draw a path between them. Continue connecting lights until all of them are linked together. Be strategic in your approach, as the paths cannot intersect, and you'll need to plan your moves carefully to solve each puzzle. Enjoy a wide variety of levels with increasing complexity and challenges. As you progress, new mechanics and obstacles may be introduced, such as barriers, portals, or limited moves, adding an extra layer of difficulty and requiring you to think creatively to find the optimal solution. Immerse yourself in visually pleasing graphics, featuring colorful lights and appealing designs. Relaxing music and sound effects further enhance the gameplay experience, creating a soothing atmosphere as you connect the lights. Connect Lights offers multiple game modes to keep you engaged. Test your skills in the classic Puzzle mode, where you'll face a series of increasingly difficult levels. Race against the clock in Time Attack mode, completing puzzles as fast as possible to earn high scores. Challenge yourself to achieve three-star ratings on each level, showcasing your mastery of the game. Compete with friends or players worldwide on leaderboards to see who can solve the puzzles with the fewest moves or shortest time. So, get ready to exercise your logical thinking and problem-solving abilities in Connect Lights. Can you conquer all the levels and illuminate the grid by connecting the lights? Give it a try and let the connections begin!"
    },
    {
      "id": 9,
      "url": "/games/crazySwitchColor/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": "Crazy Switch Color",
      "datasrc": "/games/crazySwitchColor/icons/300x300.jpg",
      "logo": "/games/crazySwitchColor/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Prepare for a mind-bending challenge in  \"Crazy Switch Color \"! Test your reflexes and coordination as you navigate through an ever-changing world of colors and obstacles. Tap the screen to guide a vibrant ball through a series of color-switching platforms. Match the color of your ball with the incoming platforms to pass through safely. But beware! The platforms change rapidly, and a wrong move will result in a game over! Stay focused and be quick because the pace gets faster and more intense as you progress. Unlock new balls with unique designs and special abilities that can help you survive longer and achieve higher scores. Challenge yourself to beat your own records or compete against friends and players worldwide on the global leaderboard. Will you be the ultimate champion of Crazy Switch Color? With its simple yet addictive gameplay, vibrant visuals, and upbeat soundtrack, Crazy Switch Color guarantees hours of thrilling and challenging entertainment. Can you react swiftly and keep up with the crazy switches? It's time to put your skills to the test!"
    },
    {
      "id": 10,
      "url": "/games/cricketLegends/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": "Cricket Legends",
      "datasrc": "/games/cricketLegends/icons/300x300.jpg",
      "logo": "/games/cricketLegends/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Step into the world of  \"Cricket Legends \" and experience the thrill of the gentleman's game in a virtual cricket simulation like never before. In Cricket Legends, you have the opportunity to play as some of the greatest cricket players of all time. Take control of legendary cricketers from different eras and compete in thrilling matches across various formats such as Test matches, One-Day Internationals (ODIs), and Twenty20 (T20) matches. Immerse yourself in realistic stadiums with detailed graphics and animations that bring the game to life. Experience the excitement of the crowd, the dynamic weather conditions, and the strategic nuances of the sport. As a player, you can choose your role in the game. Batting allows you to showcase your skills by timing your shots, playing defensive or aggressive strokes, and building partnerships with your teammates. Bowling requires mastering the art of swing, spin, and pace to deceive the batsmen and take crucial wickets. Fielding demands quick reflexes and precise positioning to stop boundaries and take catches that can turn the game around. Compete against AI-controlled teams or challenge your friends in multiplayer mode for intense cricket battles. Use your strategic acumen to make captaincy decisions, set bowling field placements, and adapt your gameplay based on the match situation. In Cricket Legends, you can also participate in career mode, where you create your own player and guide them through their cricket journey. Train, improve your skills, and rise through the ranks to become a cricket legend yourself. Unlock achievements, earn rewards, and customize your player's appearance with different equipment, jerseys, and accessories. As you progress, unlock additional stadiums, tournaments, and historical challenges to test your mettle against iconic moments from cricket history. Experience commentary from renowned cricket commentators, enhancing the authenticity and immersion of the game. Immerse yourself in the captivating atmosphere of a cricket match as you chase down targets, take wickets, and strive for victory. So, grab your bat, lace up your shoes, and step onto the pitch in Cricket Legends. It's time to showcase your cricketing prowess and etch your name among the greats of the game!"
    },
    {
      "id": 11,
      "url": "/games/dangerousDanny/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": "Dangerous Danny",
      "datasrc": "/games/dangerousDanny/icons/300x300.jpg",
      "logo": "/games/dangerousDanny/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Welcome to the thrilling world of  \"Dangerous Danny \"! Prepare yourself for an action-packed adventure with our fearless hero, Danny, as he embarks on a daring quest to save the day. In Dangerous Danny, you'll guide our courageous protagonist through a series of challenging levels filled with obstacles, enemies, and epic boss battles. Danny's mission is to rescue his friends and defeat the forces of evil that threaten their peaceful world. Navigate through vibrant and immersive environments, ranging from treacherous jungles to mysterious dungeons and futuristic cities. Run, jump, slide, and swing your way past dangerous traps and hostile creatures standing in your path. As you progress, collect power-ups and special abilities to enhance Danny's skills. Unleash devastating attacks, gain temporary invincibility, or unlock new moves that allow you to overcome even the toughest challenges. Face off against formidable bosses at the end of each level. Utilize your agility, timing, and quick reflexes to dodge their attacks and find their weak spots. Defeat them to unlock new areas and advance in your quest. Immerse yourself in stunning visuals, accompanied by an adrenaline-pumping soundtrack that enhances the excitement of the gameplay. Engage in fast-paced action sequences, solve puzzles, and uncover hidden secrets as you traverse the diverse landscapes of Dangerous Danny. Challenge yourself further by collecting hidden treasures and completing optional objectives in each level. Earn rewards, unlock bonus content, and discover the full extent of Danny's capabilities. With its engaging storyline, dynamic gameplay, and captivating visuals, Dangerous Danny offers an unforgettable gaming experience for players seeking thrills and adventure. So, gear up, embrace danger, and join Danny on his heroic journey to rescue his friends and restore peace in the world. Are you ready to face the challenges that await in Dangerous Danny? Let the adventure begin!"
    },
    {
      "id": 12,
      "url": "/games/egyptStoneWar/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": "Egypt Stone War",
      "datasrc": "/games/egyptStoneWar/icons/300x300.jpg",
      "logo": "/games/egyptStoneWar/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Welcome to  \"Egypt Stone War \"! Prepare to embark on an epic journey back in time to ancient Egypt, where you'll engage in a strategic battle for power and glory. In Egypt Stone War, you'll take on the role of a mighty Egyptian ruler competing against other civilizations for dominance. Your objective is to build and expand your empire by strategically deploying your forces, utilizing powerful artifacts, and conquering territories. Start by establishing your base camp in a strategic location within the vast Egyptian landscape. Gather resources, recruit armies, and construct various structures to strengthen your civilization's economy and military might. Navigate through beautifully rendered maps representing different regions of ancient Egypt, each with its unique challenges and opportunities. Explore deserts, conquer fertile lands along the Nile River, and strategically plan your conquests across the vast territory. Engage in tactical battles on the battlefield, employing your armies and using special abilities to gain the upper hand. Command diverse units, including archers, chariots, infantry, and mythical creatures inspired by Egyptian mythology. Employ clever strategies, exploit weaknesses, and outmaneuver your opponents to secure victory. Harness the power of ancient artifacts and invoke the blessings of Egyptian gods to gain special advantages in battle. Unleash devastating spells, summon mythical beasts, or receive divine interventions that can turn the tide of war. Form alliances with other players or wage wars against rival civilizations in multiplayer mode. Collaborate with allies, share resources, and coordinate attacks to dominate the Egyptian realm together. Immerse yourself in authentic Egyptian visuals, stunning landscapes, and captivating soundtracks that transport you to the ancient world. Experience the rich history, mythology, and culture of Egypt as you forge your path to greatness. As you progress, unlock new technologies, upgrades, and advancements that enhance your empire's capabilities. Expand your influence, establish trade routes, and construct magnificent wonders of the ancient world to showcase your dominance. So, gather your forces, lead your civilization to glory, and shape the destiny of ancient Egypt in the epic battles of Egypt Stone War. Will you rise as a legendary pharaoh or succumb to the sands of time? The fate of Egypt lies in your hands!"
    },
    {
      "id": 13,
      "url": "/games/findDiamonds/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": "Find Diamonds",
      "datasrc": "/games/findDiamonds/icons/300x300.jpg",
      "logo": "/games/findDiamonds/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": " \"Find Diamonds \" is an exciting and adventurous puzzle game where players embark on a quest to discover hidden diamonds in various levels and environments. In this captivating game, you will navigate through beautifully designed landscapes, such as lush jungles, mysterious caves, or even deep oceanic caverns. Your objective is to explore these immersive locations and uncover the elusive diamonds concealed within. As you progress through the game, each level presents unique challenges and obstacles that you must overcome. You might encounter puzzles, traps, or tricky pathways that require careful thinking and problem-solving skills to navigate successfully. To find the diamonds, you'll need to search every nook and cranny of the environment, utilizing your observational abilities to spot clues and hints. Look for sparkling gems, follow trails, decipher codes, and interact with objects to unravel the secrets leading to the precious diamonds. Be cautious, though! Some levels may include time limits or hazards that add an element of urgency and excitement to your diamond-finding journey. Stay sharp, think quickly, and make smart decisions to avoid setbacks and complete each level successfully. As you collect diamonds throughout the game, you can use them to unlock new levels, characters, or power-ups, enhancing your gameplay experience and offering additional features to aid you in your treasure-hunting adventure. Immerse yourself in visually stunning graphics, accompanied by an enchanting soundtrack that sets the mood for your exploratory mission. Enjoy the thrill of discovery and the satisfaction of locating valuable diamonds as you progress through the game. So, get ready to embark on an epic quest and demonstrate your keen eye for hidden treasures in  \"Find Diamonds. \" Will you be able to uncover all the diamonds and become the ultimate master of gem hunting? Start the adventure and find out!"
    },
    {
      "id": 14,
      "url": "/games/fishingIe/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": "Fishing Ie",
      "datasrc": "/games/fishingIe/icons/300x300.jpg",
      "logo": "/games/fishingIe/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Dive into the tranquil world of FishingIe, a captivating fishing simulation game. Experience the thrill of casting your line into serene waters as you embark on a quest to catch the biggest and rarest fish. Explore picturesque locations, from peaceful lakes to majestic oceans, each teeming with an abundance of marine life. With realistic fishing mechanics and stunning graphics, FishingIe offers an immersive angling experience like no other. Choose your favorite fishing spot, select the perfect bait and tackle, and test your skills against a wide variety of fish species. Feel the excitement as you reel in your prized catch and witness the adrenaline rush of successfully landing a legendary fish. Upgrade your fishing gear, unlock new fishing techniques, and master the art of angling as you progress through the game. Participate in tournaments and compete with fellow anglers worldwide to prove your fishing prowess. Customize your own fishing avatar and showcase your achievements in a vibrant online community. Whether you're a seasoned angler or new to the world of fishing, FishingIe offers a relaxing and engrossing gameplay experience that will satisfy your inner fishing enthusiast. Cast your line, embrace the tranquility, and become a skilled angler in FishingIe."
    },
    {
      "id": 15,
      "url": "/games/footballPenaltyKicks/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": "Football Penalty Kicks",
      "datasrc": "/games/footballPenaltyKicks/icons/300x300.jpg",
      "logo": "/games/footballPenaltyKicks/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Experience the intense pressure and exhilaration of penalty shootouts in Football Penalty Kicks! Step onto the pitch as a skilled striker and test your precision and nerve as you take on the role of both the penalty taker and the goalkeeper. In this addictive soccer game, you'll face off against formidable opponents in a series of penalty kick challenges. Use your skill and strategy to aim for the corners, dodge the keeper's dives, and score spectacular goals. As the goalkeeper, dive and make lightning-fast saves to block shots and secure victory for your team. With realistic physics and intuitive controls, Football Penalty Kicks offers a true-to-life penalty shootout experience. Compete in various tournaments and leagues, aiming to become the ultimate penalty kick champion. Earn rewards and unlock new teams, stadiums, and customization options as you progress. Immerse yourself in the atmosphere of a packed stadium with stunning graphics and crowd chants. Feel the tension rise as you step up to take the decisive penalty kick, the fate of the match resting on your shoulders. Can you handle the pressure and lead your team to victory? Whether you're a casual gamer or a die-hard football fan, Football Penalty Kicks delivers thrilling gameplay and nail-biting moments. Show off your skills, conquer the penalty shootout, and cement your legacy as a top-notch striker and goalkeeper in the world of football."
    },
    {
      "id": 16,
      "url": "/games/goblinRun/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": "Goblin Run",
      "datasrc": "/games/goblinRun/icons/300x300.jpg",
      "logo": "/games/goblinRun/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Welcome to the adrenaline-pumping world of  \"Goblin Run \"! In this wildly addictive endless runner game, you take on the role of a mischievous and nimble goblin on a thrilling adventure through mystical realms. Your mission? Outrun dangerous obstacles, navigate treacherous terrain, and collect valuable treasures along the way. As the goblin, you'll dash, jump, slide, and maneuver through vibrant and visually stunning landscapes teeming with enchanted forests, icy caves, ancient ruins, and more. Each level presents unique challenges and surprises, keeping you on the edge of your seat! Be prepared to put your reflexes to the test as you encounter menacing creatures, dodge deadly traps, and leap over bottomless chasms. The further you run, the faster the pace becomes, pushing your skills to their limits and rewarding you with even greater treasures. To aid you in your quest, power-ups and boosters are scattered throughout the game, giving you temporary abilities and augmenting your goblin's abilities. Want to unleash a fiery trail, soar through the air, or become invincible for a short time? The power-ups got you covered! And remember, as a truly mischievous goblin, there's always room for mischief! Collect prank items hidden within the levels and unleash chaos on your pursuers. Challenge your friends and fellow goblin enthusiasts to beat your high score as you rack up points, treasures, and achievements. Aim for the top spot on the global leaderboard and cement your status as the fastest, most daring goblin runner in the world! So, lace up your running shoes, sharpen those reflexes, and embark on an epic, heart-pounding adventure in  \"Goblin Run \"! The goblin realm awaits your speedy arrival! Let the race begin!"
    },
    {
      "id": 17,
      "url": "/games/hexAquaticKraken/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": "Hex Aquatic Kraken",
      "datasrc": "/games/hexAquaticKraken/icons/300x300.jpg",
      "logo": "/games/hexAquaticKraken/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Dive into a world of magic and strategy in Hex Aquatic Kraken! Discover an enchanting underwater realm where powerful Krakens reign and epic battles unfold on hexagonal game boards. In this immersive strategy game, you'll take control of a faction of aquatic creatures, including the legendary Krakens. Strategically deploy your forces, unleash devastating abilities, and outmaneuver your opponents to claim victory. The hex-based gameplay adds depth and tactical complexity, allowing for endless strategic possibilities. Experience thrilling battles as you command your Krakens and other mythical creatures. Harness their unique powers, summon reinforcements, and strategically position your units to dominate the battlefield. Adapt your tactics to counter your opponents and seize control of key objectives. As you progress through the game, unlock new Krakens with diverse abilities and customize your faction to suit your playstyle. Engage in challenging single-player campaigns, compete against friends in local multiplayer, or test your skills against players from around the world in intense online matches. Immerse yourself in the stunning visuals and immersive soundtrack that brings the underwater world of Hex Aquatic Kraken to life. Master the art of strategy, conquer the depths, and become the ultimate commander in this mesmerizing aquatic battle arena. Are you ready to unleash the power of the Hex Aquatic Kraken? Prepare for epic battles, tactical brilliance, and legendary triumph!"
    },
    {
      "id": 18,
      "url": "/games/jewelAquarium/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": "Jewel Aquarium",
      "datasrc": "/games/jewelAquarium/icons/300x300.jpg",
      "logo": "/games/jewelAquarium/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "Dive into the mesmerizing depths of  \"Jewel Aquarium \"! Immerse yourself in a world of vibrant underwater beauty as you solve puzzles and discover hidden treasures. Match and collect colorful jewels to complete each level's objectives. Strategically swap and combine gems to create powerful cascades and clear obstacles. Unlock special boosters and unleash their magical effects to overcome challenging stages. As you progress, explore different areas of the Jewel Aquarium, each with its own unique theme and set of challenges. Encounter exotic sea creatures and unlock their secrets along your journey. Collect rare artifacts and decorate your aquarium with stunning ornaments. Challenge yourself with various gameplay modes, including timed levels, limited moves, and more. Compete against friends or players worldwide to see who can achieve the highest scores and climb the leaderboard. With its captivating visuals, soothing sound effects, and addictive gameplay, Jewel Aquarium provides a relaxing and enchanting experience for players of all ages. Dive into this sparkling aquatic world and let the jewels dazzle your senses! Are you ready to embark on a match-3 adventure beneath the waves? Get ready to dive deep into the Jewel Aquarium and unravel its treasures!"
    },
    {
      "id": 19,
      "url": "/games/jewelBlocks/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": "Jewel Blocks",
      "datasrc": "/games/jewelBlocks/icons/300x300.jpg",
      "logo": "/games/jewelBlocks/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Immerse yourself in the addictive world of Jewel Blocks, a captivating puzzle game that will test your spatial skills and strategic thinking. Challenge yourself to clear the board by strategically placing colorful jewel blocks and creating complete lines. In this mesmerizing puzzle game, your goal is to fit different-shaped jewel blocks together on the grid. As you place the blocks, complete horizontal or vertical lines are formed, clearing them from the board. Be careful, as the grid fills up quickly, and if you can't make any more moves, it's game over. With its simple yet engaging gameplay mechanics, Jewel Blocks offers endless hours of fun for players of all ages. Train your brain, improve your problem-solving abilities, and discover new strategies as you strive for high scores and perfect line clears. Enjoy the soothing visuals and delightful sound effects that accompany each successful move. Compete against yourself to beat your own records or challenge friends and family to see who can achieve the highest score. Can you become the ultimate Jewel Blocks master? Whether you're looking for a quick and casual puzzle-solving session or a challenging brain teaser, Jewel Blocks is the perfect choice. Start stacking those jewel blocks and unleash your puzzle-solving skills in this addictive and rewarding game."
    },
    {
      "id": 20,
      "url": "/games/jewelDash/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": "Jewel Dash",
      "datasrc": "/games/jewelDash/icons/300x300.jpg",
      "logo": "/games/jewelDash/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Get ready for a fast-paced and addictive gem-matching adventure in Jewel Dash! In this thrilling puzzle game, your task is to match colorful jewels and clear them from the board before time runs out. Swipe and swap adjacent jewels to create lines of three or more, triggering dazzling cascades and earning points. The more jewels you match in a single move, the higher your score. Utilize special power-ups strategically to create explosive combos and clear large groups of jewels in one fell swoop. With its simple yet engaging gameplay mechanics, Jewel Dash offers endless hours of gem-matching fun. Challenge yourself in various game modes, each with its own unique objectives and challenges. Race against the clock in timed mode, strategize your moves in puzzle mode, or relax and enjoy endless gem-matching in classic mode. Immerse yourself in the vibrant visuals and immersive sound effects as you progress through the levels. Unlock new themes and backgrounds as you advance, adding a fresh visual flair to your jewel-matching journey. Compete against friends or players worldwide in the leaderboards, aiming for the top spot and proving yourself as the ultimate Jewel Dash master. Share your achievements on social media and challenge your friends to beat your high scores. Ready for some gem-matching excitement? Let the cascade of jewels begin in Jewel Dash!"
    },
    {
      "id": 21,
      "url": "/games/jurassicRun/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": "Jurassic Run",
      "datasrc": "/games/jurassicRun/icons/300x300.jpg",
      "logo": "/games/jurassicRun/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Embark on an exhilarating adventure in  \"Jurassic Run \"! Get ready to run for your life as you find yourself trapped in a prehistoric world filled with fearsome dinosaurs. As the fearless protagonist, you must navigate through treacherous landscapes while evading the jaws of massive predators. Run, jump, and slide your way past obstacles and deadly creatures that lurk around every corner. Explore the lush and dangerous environments of the Jurassic era, from dense jungles to towering cliffs. Collect power-ups and special items along the way to aid in your escape and increase your chances of survival. But beware! The dinosaurs of the Jurassic period are relentless hunters. Stay one step ahead of their pursuit, utilize your agility, and make split-second decisions to avoid becoming their next meal. With stunning visuals, realistic sound effects, and thrilling gameplay, Jurassic Run delivers an immersive experience that will keep you on the edge of your seat. Can you outrun the ancient beasts and find your way back to safety? Challenge yourself in different game modes, unlock achievements, and compete against friends or players worldwide for the highest scores. Unleash your inner adventurer and prepare for a wild, heart-pounding chase in Jurassic Run!"
    },
    {
      "id": 22,
      "url": "/games/kidsCutePairs/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": "Kids Cute Pairs",
      "datasrc": "/games/kidsCutePairs/icons/300x300.jpg",
      "logo": "/games/kidsCutePairs/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Welcome to the whimsical world of  \"Kids Cute Paris \"! Embark on a delightful journey through the enchanting streets of Paris, where imagination and creativity know no bounds. Join a group of adorable kids as they explore iconic landmarks such as the Eiffel Tower, Louvre Museum, and charming Parisian neighborhoods. Engage in a variety of fun and educational activities that will ignite your child's curiosity and spark their creativity. Unleash your artistic talents with coloring pages inspired by famous French masterpieces or design your own fashionable outfits at a virtual Parisian fashion show. Solve puzzles, complete quests, and discover hidden surprises as you navigate through the city's enchanting streets. Immerse yourself in the rich culture and history of Paris through interactive storytelling and engaging mini-games. Learn interesting facts about landmarks, famous artists, and French cuisine while having loads of fun. With its vibrant visuals, cheerful music, and age-appropriate gameplay, Kids Cute Paris offers an immersive and educational experience for young adventurers. Foster imagination, develop cognitive skills, and ignite a love for learning in a playful and exciting environment. Are you ready for a captivating journey through the magical streets of Paris? Join the Kids Cute Paris crew and let the adventure begin!"
    },
    {
      "id": 23,
      "url": "/games/ludoLegend/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": "Ludo Legend",
      "datasrc": "/games/ludoLegend/icons/300x300.jpg",
      "logo": "/games/ludoLegend/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Step into the world of Ludo Legend, a classic board game brought to life with modern features and exciting gameplay. Gather your friends or challenge AI opponents in this multiplayer game where strategy and luck go hand in hand. In Ludo Legend, your goal is to move all your tokens from the starting area to the center of the board. Roll the dice and strategically navigate your tokens across the board, avoiding obstacles and opponents' tokens. Use shortcuts and strategic moves to gain an advantage and reach the finish line before your opponents do. Play against up to three other players locally or compete against computer-controlled opponents at various difficulty levels. Enjoy the interactive board with colorful visuals and immersive animations that enhance the gaming experience. Customize your game by choosing different themes, token designs, and rule variations. Whether you prefer the classic rules or want to add your own twists, Ludo Legend offers flexibility for a personalized gameplay experience. Challenge your friends in private matches or play online against players from around the world. Rise through the ranks, unlock achievements, and climb the global leaderboards to showcase your Ludo skills. With its simple rules, engaging gameplay, and social interaction, Ludo Legend brings the beloved board game to your fingertips. Gather your family and friends, roll the dice, and let the race to victory begin in Ludo Legend!"
    },
    {
      "id": 24,
      "url": "/games/pizzaNinjaMania/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": "Pizza Ninja Mania",
      "datasrc": "/games/pizzaNinjaMania/icons/300x300.jpg",
      "logo": "/games/pizzaNinjaMania/icons/300x300.jpg",
      "tag": "hot",
      "rating": 3.5,
      "synopsis": "Welcome to Pizza Ninja Mania, a fast-paced and deliciously fun game where you become a master pizza ninja! Slice and dice your way through a variety of mouth-watering pizzas while avoiding dangerous obstacles and achieving high scores. In this exciting arcade game, your task is to slice the flying pizzas that appear on the screen. Use your ninja skills to swipe across the screen and cut the pizzas into perfect slices. Be careful not to touch any bombs or other harmful objects that may be mixed in with the pizzas. The game features different modes and challenges to keep you entertained. In Classic Mode, test your reflexes as you slice as many pizzas as possible within the given time limit. Challenge Mode offers unique objectives and obstacles to overcome, adding an extra layer of excitement to the gameplay. As you progress, unlock new toppings, backgrounds, and power-ups that enhance your slicing abilities. Master the art of precision slicing to create combos and earn bonus points. Aim for the highest score and compete against your friends or players worldwide on the leaderboards. Experience vibrant and colorful graphics, accompanied by energetic music and sound effects that immerse you in the world of Pizza Ninja Mania. The intuitive controls make it easy to pick up and play, ensuring a delightful gaming experience for all. Get ready to unleash your inner pizza ninja and satisfy your craving for fun in Pizza Ninja Mania! Start slicing those pizzas and show off your skills in this addictive and entertaining game."
    },
    {
      "id": 25,
      "url": "/games/powerWall/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": "Power Wall",
      "datasrc": "/games/powerWall/icons/300x300.jpg",
      "logo": "/games/powerWall/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "In PowerWall, you control a futuristic runner equipped with a high-tech suit capable of manipulating electricity. Your mission is to traverse a series of intricately designed levels, each filled with challenges that test your agility, timing, and problem-solving skills. The gameplay is fast-paced and intense, requiring split-second decisions to overcome obstacles such as electrified barriers, moving platforms, and sudden changes in terrain."
    },
    {
      "id": 26,
      "url": "/games/puzzleWorld/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": "Puzzle World",
      "datasrc": "/games/puzzleWorld/icons/300x300.jpg",
      "logo": "/games/puzzleWorld/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Welcome to Puzzle World, a captivating puzzle game that takes you on an enchanting journey through diverse and immersive puzzles. Immerse yourself in a world of brain-teasing challenges, engaging mechanics, and visually stunning landscapes. In Puzzle World, your goal is to solve a wide variety of puzzles across different themes and difficulty levels. From classic jigsaw puzzles to shape matching, logic puzzles, and more, each puzzle offers a unique and satisfying experience. Discover stunning visuals as you unlock new levels and explore various locations within Puzzle World. Solve puzzles set in lush forests, ancient ruins, bustling cities, underwater realms, and other breathtaking environments. Each scene comes to life as you piece together the puzzles. The game features intuitive controls, allowing you to drag and drop puzzle pieces or interact with elements seamlessly. Enjoy smooth animations and soothing background music that enhances the overall gameplay experience. Puzzle World offers a range of gameplay modes to suit your preferences. Challenge yourself in timed modes for an extra thrill, or relax and take your time in casual modes. Earn stars and unlock achievements as you progress, showcasing your puzzle-solving prowess. Engage in friendly competition by comparing your scores and completion times with friends or players worldwide on the leaderboards. Share your favorite puzzles and achievements with others, or collaborate with friends to solve puzzles together. With its ever-expanding collection of puzzles and captivating gameplay, Puzzle World provides endless hours of entertainment for puzzle enthusiasts of all ages. It's a perfect companion for leisurely relaxation or stimulating mental exercise. Are you ready to embark on an exciting journey through Puzzle World? Prepare to unravel mysteries, challenge your mind, and experience the joy of solving puzzles in this mesmerizing puzzle adventure."
    },
    {
      "id": 27,
      "url": "/games/rapunzelTower/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": "Rapunzel Tower",
      "datasrc": "/games/rapunzelTower/icons/300x300.jpg",
      "logo": "/games/rapunzelTower/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Welcome to Rapunzel Tower, an enchanting puzzle game inspired by the classic fairy tale. Join Rapunzel in her tower and help her escape by solving a series of challenging puzzles. In this captivating puzzle adventure, your goal is to guide Rapunzel from the top of the tower to the ground safely. Maneuver through levels filled with obstacles, traps, and unique puzzle mechanics. Use your problem-solving skills to find the correct path and overcome each challenge. Each level presents a different puzzle or obstacle that you must navigate through. Move platforms, activate switches, avoid spikes, and manipulate objects to clear the way for Rapunzel's descent. Be careful not to make any wrong moves, as it could lead to Rapunzel being trapped in the tower forever. Immerse yourself in the beautiful graphics and enchanting atmosphere of Rapunzel's tower. Explore intricately designed levels that capture the magic and charm of the fairy tale. Enjoy soothing music and sound effects that enhance the gameplay experience. With its intuitive controls and gradually increasing difficulty, Rapunzel Tower offers a rewarding experience for players of all ages. Test your logic, timing, and spatial awareness as you progress through the levels. Collect stars along the way to unlock bonus content and additional challenges. Aim for the highest score and compete against friends or players worldwide on the leaderboards. Embark on a journey of puzzle-solving and help Rapunzel escape her tower in Rapunzel Tower. Are you ready to unravel the mysteries and guide Rapunzel to freedom? Let the adventure begin!"
    },
    {
      "id": 28,
      "url": "/games/realTennis/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": "Real Tennis",
      "datasrc": "/games/realTennis/icons/300x300.jpg",
      "logo": "/games/realTennis/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Step onto the tennis court and experience the excitement of the sport with Real Tennis! Immerse yourself in the realistic gameplay, precise controls, and thrilling matches that will test your skills and strategy. In Real Tennis, you'll engage in intense one-on-one tennis matches against skilled opponents. Play on various court surfaces, including grass, clay, and hard courts, each providing a unique playing experience. Use your racket to serve, volley, and smash your way to victory. The game offers intuitive controls that allow you to perform a wide range of shots with accuracy and precision. Master different stroke techniques, such as forehands, backhands, slices, and lobs, to outmaneuver your opponent and control the pace of the game. Choose from a roster of professional tennis players or create your own custom character. Customize your player's appearance, attributes, and playing style to suit your preferences. As you progress, unlock new equipment and upgrades to enhance your performance on the court. Experience stunning graphics and realistic animations that bring the tennis matches to life. From the fluid movements of the players to the detailed court environments, every aspect of the game is designed to provide an immersive and authentic tennis experience. Real Tennis features various game modes to keep you entertained. Engage in career mode, where you can rise through the rankings, compete in tournaments, and claim championship titles. Take on quick matches for a fast-paced gameplay experience or challenge friends in local or online multiplayer matches. Improve your skills by participating in training exercises and mini-games that focus on specific aspects of the game. Master your timing, shot placement, and strategic decision-making to become a formidable force on the court. Are you ready to step into the world of Real Tennis? Grab your racket, hit the court, and show off your skills in thrilling matches. It's time to serve, rally, and dominate the game of tennis like a true champion!"
    },
    {
      "id": 29,
      "url": "/games/reversiMania/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": "Reversi Mania",
      "datasrc": "/games/reversiMania/icons/300x300.jpg",
      "logo": "/games/reversiMania/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "Get ready for a strategic and addictive board game experience with Reversi Mania! Enter the world of this classic game, also known as Othello, and engage in thrilling battles of wit and strategy. In Reversi Mania, your goal is to dominate the game board by strategically placing your colored discs and flipping your opponent's pieces to gain control. The objective is to have the majority of your discs on the board when the game ends. The rules are simple yet offer endless possibilities for tactical gameplay. Place your discs strategically to create lines, diagonals, and patterns that allow you to flip your opponent's pieces. Plan your moves carefully to outmaneuver your opponent and secure victory. Reversi Mania offers different game modes to cater to your preferences. Engage in single-player mode and challenge various AI difficulty levels to test your skills. Play against friends and family in local multiplayer mode, or go online to compete against players from around the world. Immerse yourself in clean and visually appealing graphics that enhance the gameplay experience. The smooth animations and intuitive interface make it easy to play and focus on your strategic decisions. Track your progress with statistics and leaderboards that showcase your performance and skill level. Aim for high rankings and unlock achievements as you become a Reversi master. Whether you're a beginner learning the ropes or a seasoned player seeking a challenging opponent, Reversi Mania provides hours of fun and strategic gameplay. Sharpen your mind, anticipate your opponent's moves, and conquer the board in this exciting adaptation of the classic Reversi game. So, gather your wits, plan your moves, and get ready to experience the thrill of Reversi Mania! Can you outsmart your opponents and emerge victorious? It's time to show off your strategic prowess and dominate the board!"
    },
    {
      "id": 30,
      "url": "/games/skyBridge/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": "Sky Bridge",
      "datasrc": "/games/skyBridge/icons/300x300.jpg",
      "logo": "/games/skyBridge/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Prepare for an adrenaline-fueled adventure in the sky with Sky Bridge! Take on the challenge of constructing and navigating precarious bridges high above the ground in this thrilling physics-based game. In Sky Bridge, your mission is to build sturdy bridges that can withstand the weight and movement of vehicles crossing over them. As the bridge architect, you'll need to use your engineering skills to design strong and reliable structures. Carefully place beams, trusses, and supports to create a secure pathway from one end to the other. But it's not just about construction—once the bridge is built, you must test its durability by driving different vehicles across it. From cars and trucks to heavy-duty machinery, each vehicle presents a unique challenge. Make sure your bridge can handle the weight, balance, and vibrations as the vehicles traverse it. The game features realistic physics simulation, so every beam and joint will affect the stability and performance of your bridge. Take into account factors such as weight distribution, tension, and compression to ensure your bridge remains intact. Challenge yourself with increasingly difficult levels that require more complex bridge designs. Face obstacles such as gaps, hills, and even moving platforms that demand precise timing and construction techniques. Immerse yourself in immersive 3D environments with stunning landscapes. From lush forests and deep canyons to towering mountains and city skylines, each level offers a visually captivating backdrop for your engineering feats. Sky Bridge encourages creativity and experimentation. Don't be afraid to think outside the box and try unconventional bridge designs. Test different materials, angles, and shapes to find the most efficient and cost-effective solutions. Compete against other players in online leaderboards and showcase your bridge-building skills. Share your best creations with friends and challenge them to beat your records. Are you ready to become a master bridge builder? Get your blueprint ready, select your materials, and start constructing your way across the sky in Sky Bridge. It's time to bridge the gap and defy gravity with your engineering prowess!"
    },
    {
      "id": 31,
      "url": "/games/soccerChamp/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": "Soccer Champ",
      "datasrc": "/games/soccerChamp/icons/300x300.jpg",
      "logo": "/games/soccerChamp/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Step onto the soccer field and become a legendary Soccer Champ! Experience the thrill of competitive football as you dribble, pass, and score your way to victory in this action-packed sports game. In Soccer Champ, your goal is to lead your team to glory by winning matches against formidable opponents. Showcase your skills in fast-paced gameplay, where precise ball control, strategic passes, and accurate shots are the keys to success. The game offers intuitive controls that allow you to maneuver your player with ease. Use on-screen buttons or swipe gestures to navigate the field, perform skillful moves, and outmaneuver defenders. Time your passes and shots perfectly to score spectacular goals and outwit the opposing goalkeeper. Immerse yourself in stunning 3D graphics, realistic animations, and dynamic camera angles that capture the excitement of real football matches. Feel the energy of the crowd as they cheer for every goal and tackle, adding to the immersive atmosphere of the game. Soccer Champ offers various game modes to test your skills and entertain you. Engage in thrilling single-player tournaments or embark on a career mode, where you can rise through the ranks and lead your team to championships. Participate in challenging multiplayer matches and compete against friends or players from around the world to prove your dominance on the field. Customize your player's appearance, including hairstyles, jerseys, boots, and accessories, to create your unique soccer superstar. Unlock new stadiums, equipment, and upgrades as you progress and earn rewards for your outstanding performances. Sharpen your skills in training exercises that focus on different aspects of the game, such as shooting accuracy, passing precision, and defensive techniques. Master these skills to become an unstoppable force in Soccer Champ. With realistic gameplay, immersive visuals, and addictive competition, Soccer Champ delivers the ultimate soccer experience on your fingertips. Are you ready to take your team to victory and become the ultimate Soccer Champ? Lace up your boots, step onto the pitch, and let the games begin!"
    },
    {
      "id": 32,
      "url": "/games/solitaireGrande/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": "Solitaire Grande",
      "datasrc": "/games/solitaireGrande/icons/300x300.jpg",
      "logo": "/games/solitaireGrande/icons/300x300.jpg",
      "tag": "hot",
      "rating": 3.5,
      "synopsis": "Welcome to the world of Solitaire Grande! Get ready to test your card skills and indulge in the classic game of solitaire. In Solitaire Grande, your objective is to arrange all the cards in a specific order by suit and rank. Start with a shuffled deck of cards and strategically move them around on the tableau, building foundations from Ace to King in each suit. Follow the rules of traditional solitaire as you stack cards in alternating colors and descending order. Use your intuition and strategic thinking to uncover hidden cards, make clever moves, and create sequences that will help you clear the tableau and ultimately win the game. Engage in different variations of solitaire, such as Klondike, Spider, FreeCell, and more. Each variation offers unique challenges and gameplay mechanics to keep you entertained and engaged for hours. Customize your gaming experience by choosing from various card designs and backgrounds that suit your preferences. Play at your own pace, relax your mind, and enjoy the tranquil ambiance created by soothing music and beautiful visuals. Track your progress, challenge yourself with daily or weekly goals, and compete against friends or players worldwide on the leaderboard. Can you achieve the highest scores and become a Solitaire Grande master? With its timeless gameplay, intuitive controls, and endless entertainment, Solitaire Grande offers a classic and addictive experience that can be enjoyed by players of all ages. So shuffle the cards, sharpen your wits, and dive into the world of Solitaire Grande! Let the solitaire fun begin!"
    },
    {
      "id": 33,
      "url": "/games/spiderSolitaire/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": "Spider Solitaire",
      "datasrc": "/games/spiderSolitaire/icons/300x300.jpg",
      "logo": "/games/spiderSolitaire/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Welcome to the captivating world of Spider Solitaire! Get ready to test your patience, strategy, and card-playing skills in this challenging variation of the classic solitaire game. In Spider Solitaire, your goal is to arrange all the cards in descending order within each suit. Start with a tableau of ten stacks of cards, some facedown and others face up. Your task is to build sequences of cards, regardless of suit, in descending order from King to Ace. The challenge lies in creating complete sequences, which can then be moved to the foundation piles. To assist you, you can move cards between tableau columns, but only if they are in proper descending order. Once a column is cleared of all its cards, it becomes an empty space that you can utilize strategically. Spider Solitaire offers different levels of difficulty, allowing you to choose the number of suits and customize the game to match your skill level. The more suits you play with, the more challenging and intricate the game becomes. Exercise your strategic thinking and planning abilities as you navigate through the intricate tableau. Keep an eye on the hidden cards and make wise moves to uncover them and create new sequences. With its simple yet addictive gameplay, Spider Solitaire provides endless hours of entertainment for solitaire enthusiasts. Challenge yourself to beat your own records or compete against friends to see who can achieve the highest scores. So, gather your patience, sharpen your focus, and get ready for an enthralling game of Spider Solitaire!"
    },
    {
      "id": 34,
      "url": "/games/tinyArcher/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": "Tiny Archer",
      "datasrc": "/games/tinyArcher/icons/300x300.jpg",
      "logo": "/games/tinyArcher/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Embark on an epic adventure as a skilled archer in Tiny Archer! Step into the shoes of a brave and nimble archer, defending your kingdom from hordes of enemies in this captivating action game. In Tiny Archer, you'll find yourself standing atop a tower, armed with a trusty bow and arrow. Your task is to take aim, draw back your bowstring, and release precise shots to eliminate approaching enemies. Each successful shot brings you one step closer to victory. The game offers intuitive controls that allow you to aim and shoot with ease. Simply swipe on the screen to adjust your aim and release to let your arrows fly. Time your shots carefully to hit moving targets or exploit weaknesses in enemy armor for maximum impact. Immerse yourself in charming and colorful graphics that bring the fantasy world to life. Explore different landscapes, from lush forests and snow-capped mountains to winding castle corridors. The whimsical art style adds a delightful touch to the game's atmosphere. Tiny Archer features multiple game modes to keep you engaged. Engage in a campaign mode where you embark on a quest to save your kingdom from a relentless enemy invasion. Encounter challenging boss battles and overcome obstacles as you progress through the story. Test your skills in endless mode, where you face an unending onslaught of enemies. Survive as long as possible and earn high scores to climb up the leaderboard. Challenge your friends and see who can achieve the highest score. Unlock and upgrade various bows, arrows, and special abilities to enhance your archery skills. Discover new power-ups that provide temporary boosts, such as explosive arrows or rapid fire, giving you an edge in battle. As you progress, recruit companions who will fight alongside you, each with unique abilities and strengths. Strategically deploy your companions to support your archery skills and turn the tide of battle in your favor. With its addictive gameplay, charming visuals, and satisfying archery mechanics, Tiny Archer delivers an immersive experience for archery enthusiasts and casual gamers alike. Can you stand as the tiny but mighty archer who defends the kingdom against all odds? Take aim and let your arrows fly in Tiny Archer!"
    },
    {
      "id": 35,
      "url": "/games/towerBoxer/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": "Tower Boxer",
      "datasrc": "/games/towerBoxer/icons/300x300.jpg",
      "logo": "/games/towerBoxer/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Enter the ring and unleash your boxing skills in Tower Boxer! Step into the shoes of a formidable boxer and ascend the heights of a towering skyscraper, defeating opponents on each floor in this exciting arcade-style game. In Tower Boxer, you'll face a series of challenging boxing matches as you make your way up the floors of a massive tower. Your goal is to knock out each opponent and advance to the next level. With nimble footwork, lightning-fast punches, and precise timing, you must defeat all challengers to reach the top. The game offers simple yet addictive controls that make it easy to throw punches and dodge incoming attacks. Use on-screen buttons or gestures to perform jabs, hooks, uppercuts, and defensive maneuvers. Master the art of timing and anticipation to land devastating combos and avoid getting hit. Immerse yourself in vibrant and energetic visuals as you progress through each floor of the tower. Each new level presents a different backdrop, from sleek cityscapes to neon-lit arenas, adding variety to the gameplay experience. Tower Boxer features a diverse roster of opponents, each with their own unique fighting style and abilities. Analyze their moves, study their patterns, and exploit their weaknesses to gain the upper hand in battle. Adapt your strategy to overcome increasingly challenging opponents as you climb higher. As you progress, unlock new boxing gloves, gear, and skills that enhance your performance in the ring. Customize your boxer's appearance with different outfits, hairstyles, tattoos, and more. Level up your character to increase stats and become an unstoppable force in the tower. Challenge yourself in endless mode, where you can test your endurance and see how many opponents you can defeat in a row. Aim for high scores and compete against players worldwide to claim the top spot on the leaderboard. Tower Boxer offers an engaging and fast-paced boxing experience that will keep you hooked for hours. Are you ready to prove yourself as the ultimate tower boxer? Step into the ring, lace up your gloves, and unleash your punches in this thrilling arcade boxing game!"
    },
    {
      "id": 36,
      "url": "/games/towerDefense/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": "Tower Defense",
      "datasrc": "/games/towerDefense/icons/300x300.jpg",
      "logo": "/games/towerDefense/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Prepare for an epic battle against waves of enemies in Tower Defense! Strategically place powerful towers along the enemy's path to stop their advance and protect your territory in this popular and addictive strategy game. In Tower Defense, your objective is to build a formidable defense by strategically placing different types of towers. Each tower has unique abilities and attacks, such as shooting projectiles, launching area-of-effect spells, or slowing down enemies. Your goal is to find the perfect combination of towers to effectively defeat the incoming waves of enemies. The game provides a variety of maps and environments for you to defend. From lush forests and desert wastelands to futuristic cities and haunted graveyards, each level offers its own challenges and strategic opportunities. Plan your tower placement wisely to create mazes and chokepoints that maximize the effectiveness of your defenses. Consider the strengths and weaknesses of different enemy types and adjust your strategies accordingly. Upgrade your towers to increase their power, range, and special abilities as you earn resources from defeating enemies. Tower Defense features multiple game modes to keep you engaged. Engage in the campaign mode and progress through a series of increasingly difficult levels with unique objectives. Face off against powerful boss enemies and unlock new towers and upgrades as you conquer each stage. Test your skills in endless mode, where you face an endless onslaught of enemies and strive for the highest score possible. Challenge your friends and compete on the leaderboards to prove who has the most effective defensive strategies. Enjoy immersive visuals and captivating sound effects that bring the battles to life. Watch as your towers unleash devastating attacks and decimate the enemy forces in spectacular fashion. With its addictive gameplay, strategic depth, and endless replayability, Tower Defense offers hours of enjoyment for strategy enthusiasts. Can you defend your territory and emerge victorious against the relentless enemy hordes? Build your towers, strategize your defenses, and let the battle begin in Tower Defense!"
    },
    {
      "id": 37,
      "url": "/games/twoAliensEscape/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": "Two Aliens Escape",
      "datasrc": "/games/twoAliensEscape/icons/300x300.jpg",
      "logo": "/games/twoAliensEscape/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Join a thrilling extraterrestrial adventure in Two Aliens Escape! Take control of two courageous aliens as they navigate through a series of challenging puzzles and obstacles to find their way back home. In Two Aliens Escape, your goal is to help the two aliens overcome various challenges and escape from an unfamiliar planet. Each alien possesses unique abilities that you must utilize strategically to solve puzzles and progress through the levels. The game offers intuitive controls that allow you to switch between the two aliens with a simple tap or button press. Coordinate their movements, abilities, and cooperation to overcome obstacles, activate switches, and outsmart enemies. Immerse yourself in captivating and visually stunning environments as you explore the alien planet. Traverse through lush forests, treacherous caves, ancient ruins, and futuristic cities, each filled with secrets and surprises. Two Aliens Escape features a wide range of puzzles and brain-teasers that will test your problem-solving skills. Use the aliens' abilities, such as telekinesis, shape-shifting, or gravity manipulation, to manipulate objects, unlock doors, and overcome environmental hazards. Encounter hostile creatures, traps, and other dangers that stand in the aliens' way. Timing, coordination, and quick thinking are essential to avoid threats and keep the aliens safe on their journey. Discover hidden collectibles and unlock bonus levels as you explore the intricate levels. Unravel the mysteries of the alien planet and uncover the secrets of the aliens' origin. Enjoy a heartwarming storyline filled with humor, friendship, and the determination of the two aliens to return home. Engage with charming characters and encounter unexpected twists and turns along the way. With its captivating gameplay, engaging puzzles, and immersive visuals, Two Aliens Escape provides an unforgettable gaming experience for players of all ages. Are you ready to guide the two brave aliens on their interstellar quest? Embark on the adventure, solve the puzzles, and help them find their way back home!"
    },
    {
      "id": 38,
      "url": "/games/unpark/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": "Unpark",
      "datasrc": "/games/unpark/icons/300x300.jpg",
      "logo": "/games/unpark/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "Get ready to test your parking skills in Unpark! Take on the challenge of maneuvering and unparking vehicles in various tight parking spaces in this addictive puzzle game. In Unpark, your objective is to guide the parked vehicles out of their designated parking spots by strategically moving other vehicles blocking their paths. The game presents you with a grid-like parking lot filled with cars and obstacles. Your task is to plan your moves and find a way to clear a path for the target vehicle to exit the parking lot. The game offers simple and intuitive controls that allow you to slide the vehicles horizontally or vertically within the grid. Analyze the position of each vehicle and carefully strategize your moves to create an unobstructed route for the target vehicle to follow. As you progress through the levels, the puzzles become increasingly challenging, requiring more complex maneuvers and precise planning. You'll encounter different types of vehicles with varying sizes and movement restrictions, adding an extra layer of difficulty to the puzzles. Unpark features a wide range of parking lots, each with its own unique layout and obstacles. From crowded city streets to multi-level parking garages, every level provides a new and exciting puzzle-solving experience. Challenge yourself to complete each level using the fewest possible moves to earn higher scores and unlock additional content. With each successful unparking, you'll feel a sense of accomplishment as you master the art of spatial reasoning and puzzle-solving. Immerse yourself in clean and minimalistic visuals that focus on the puzzle-solving aspect of the game. Enjoy smooth animations and satisfying sound effects as you successfully navigate the vehicles out of their parking spaces. Unpark is a casual and addictive puzzle game that will put your parking and problem-solving skills to the test. Can you strategically move the vehicles and unpark them all? Clear the way and show off your parking prowess in Unpark!"
    },
    {
      "id": 39,
      "url": "/games/worldFlagsQuiz/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": "World Flags Quiz",
      "datasrc": "/games/worldFlagsQuiz/icons/300x300.jpg",
      "logo": "/games/worldFlagsQuiz/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Test your knowledge of world flags in the exciting game World Flags Quiz! Challenge yourself to identify flags from different countries and learn about the diverse cultures and nations of the world. In World Flags Quiz, you'll be presented with flag images one by one. Your task is to correctly identify the country associated with each flag. Type in the name of the country or select from multiple-choice options to make your guess. The game offers various difficulty levels to cater to different levels of flag knowledge. Start with easier levels that feature flags of well-known countries, and progress to more challenging levels with flags of lesser-known or obscure nations. Learn fascinating facts and trivia about each country as you encounter their flags. Expand your geographical knowledge and discover new countries and their unique symbols through the flags they represent. World Flags Quiz provides hints and lifelines to assist you along the way. Use hints to get clues about the country or its location, and utilize lifelines to narrow down your options when selecting the correct answer. Track your performance and strive for high scores. The game keeps a record of your progress, including your accuracy rate and completion time. Aim to improve your scores, set new records, and challenge yourself to become a world flags expert. Immerse yourself in colorful and vibrant flag designs that reflect the diverse cultures and histories of different countries. Enjoy a user-friendly interface that makes it easy to navigate through the quiz and focus on the flags themselves. Whether you're a geography enthusiast, a trivia lover, or someone who simply wants to expand their knowledge of world flags, World Flags Quiz offers an engaging and educational experience. Test your flag recognition skills, explore the world through its flags, and become a global flag connoisseur!"
    },
    {
      "id": 40,
      "url": "/games/zigZag/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": "Zig Zag",
      "datasrc": "/games/zigZag/icons/300x300.jpg",
      "logo": "/games/zigZag/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Embark on a fast-paced and addictive journey in Zig Zag! Test your reflexes and agility as you guide a rolling ball through an endless zigzag path in this challenging arcade game. In Zig Zag, your goal is to keep the ball moving along the zigzag path for as long as possible. The path consists of sharp turns and twists, and your task is to time your taps or screen swipes to make the ball change direction at the right moment. Be careful not to fall off the edge or collide with the walls, as it will end the game. The game offers simple controls that make it easy to play but difficult to master. Tap the screen or swipe in the desired direction to make the ball change its course. The longer you survive and stay on the path, the more points you earn. Immerse yourself in minimalistic and visually pleasing graphics that focus on the gameplay experience. Enjoy smooth animations and vibrant colors as you navigate through the ever-changing zigzag path. Zig Zag features dynamic levels with randomly generated paths, ensuring a unique gameplay experience with each playthrough. Stay focused and adapt quickly as the speed and complexity of the path increase the longer you survive. Challenge yourself to achieve high scores and compete against friends or players worldwide on the leaderboard. Aim for precision and flawless timing to become the ultimate Zig Zag champion. With its addictive gameplay, simple mechanics, and endless challenges, Zig Zag provides hours of entertainment for casual gamers and those seeking a quick gaming session. Can you navigate the ball through the intricate twists and turns of the zigzag path? Test your reflexes, sharpen your skills, and conquer the zigzag in this thrilling arcade game!"
    },
    {
      "id": 41,
      "url": "/games/zombieHunter/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": "Zombie Hunter",
      "datasrc": "/games/zombieHunter/icons/300x300.jpg",
      "logo": "/games/zombieHunter/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Prepare for a heart-pounding battle against hordes of the undead in Zombie Hunter! Take on the role of a skilled and fearless zombie hunter as you fight to survive in a post-apocalyptic world overrun by zombies. In Zombie Hunter, your objective is to eliminate waves of zombies and protect yourself and other survivors from the relentless onslaught. Armed with an arsenal of weapons, including firearms, melee weapons, and explosives, you must navigate through various environments and take down the walking dead. The game offers a variety of gameplay modes to suit different preferences. Engage in story mode and uncover the secrets behind the zombie outbreak as you progress through a series of challenging missions. Each mission presents unique objectives, such as rescuing survivors, retrieving supplies, or clearing infested areas. Alternatively, test your survival skills in endless mode, where the waves of zombies become increasingly difficult to fend off. See how long you can last and compete for high scores against other players. Upgrade your weapons, unlock new gear, and acquire powerful abilities to enhance your zombie-slaying capabilities. Earn currency and rewards by completing missions and objectives, allowing you to further customize your character and improve their combat effectiveness. Immerse yourself in immersive 3D graphics and realistic sound effects that bring the zombie-infested world to life. Experience intense and visceral combat as you engage in fast-paced battles with the undead. Utilize strategic tactics to outsmart and overcome different types of zombies, each with their own strengths and weaknesses. Aim for headshots, exploit environmental hazards, and use your surroundings to gain an advantage in the fight for survival. Collaborate with other players in cooperative multiplayer mode, where you can team up with friends or other online players to tackle challenges and defeat powerful boss zombies. Zombie Hunter delivers an adrenaline-pumping zombie hunting experience that will keep you on the edge of your seat. Can you survive the zombie apocalypse and restore humanity's hope? Load your weapons, gather your courage, and become the ultimate Zombie Hunter!"
    },
    {
      "id": 42,
      "url": "/games/zombieRoad/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": "Zombie Road",
      "datasrc": "/games/zombieRoad/icons/300x300.jpg",
      "logo": "/games/zombieRoad/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Gear up for a thrilling and action-packed journey through a zombie-infested wasteland in Zombie Road! Take on the role of a daring survivor as you navigate treacherous roads, mow down hordes of zombies, and reach safety in this intense driving and shooting game. In Zombie Road, your objective is to drive as far as possible while annihilating the undead along the way. Jump behind the wheel of powerful vehicles armed with devastating weapons, and unleash chaos upon the zombie horde that stands in your path. The game offers various game modes to keep you engaged. Engage in the story mode and follow an immersive narrative as you complete missions, rescue survivors, and uncover the secrets behind the zombie outbreak. Each mission presents its own challenges and objectives, testing your driving and combat skills. In endless mode, experience non-stop zombie mayhem as you strive to cover as much distance as possible. Encounter increasingly challenging waves of zombies and compete for the highest scores on the global leaderboard. Customize and upgrade your vehicles with armor, weapons, and enhancements to improve their performance and survivability. Unlock new vehicles with unique abilities and unleash devastating special attacks to decimate the undead. Navigate through different environments, including desolate highways, eerie forests, and abandoned cities, each teeming with zombies and obstacles. Dodge wrecked vehicles, barricades, and other hazards as you race towards safety. Immerse yourself in stunning 3D graphics and realistic sound effects that amplify the intensity of the zombie apocalypse. Experience dynamic weather conditions and day-night cycles that add to the immersive gameplay. Collect resources and power-ups scattered throughout the levels to replenish ammo, restore health, and boost your vehicle's capabilities. Use strategy and quick reflexes to overcome challenging situations and escape the clutches of the undead. With its thrilling gameplay, explosive action, and gripping storyline, Zombie Road will keep you entertained for hours. Can you navigate the perilous roads, obliterate zombies with precision, and survive the apocalypse? Get behind the wheel, unleash devastation, and conquer the Zombie Road!"
    },
    {
      "id": 43,
      "url": "/games/zooEscape/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": "Zoo Escape",
      "datasrc": "/games/zooEscape/icons/300x300.jpg",
      "logo": "/games/zooEscape/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4.5,
      "synopsis": "Welcome to the thrilling world of  \"Zoo Escape \"! Get ready for an adventure where cunning animals outsmart their captors and make a daring escape from the zoo. In Zoo Escape, you'll take on the role of a clever animal who's had enough of captivity. Your goal is to navigate through various levels, each representing different areas of the zoo, and find a way to freedom. Use your wit, agility, and problem-solving skills to overcome obstacles, solve puzzles, and outmaneuver zookeepers and security systems. Sneak past guards, distract them with clever tactics, and find hidden paths to progress further in your escape plan. You'll encounter different challenges as you explore the zoo, including locked gates, laser beams, and other intricate security measures. Strategize your moves, time your actions carefully, and avoid detection to ensure a successful escape. Gather fellow animal allies along the way, each with unique abilities that can aid in your escape. Work together to overcome obstacles and unlock new areas of the zoo. Explore vibrant and detailed environments, packed with interactive elements and surprises. Discover secret passages, collect valuable items, and uncover the truth behind your captivity as you make your way towards freedom. With its captivating storyline, challenging gameplay, and immersive visuals, Zoo Escape offers an exciting and unforgettable escapade for players of all ages. Are you ready to join forces with fellow captive animals and break free from the confines of the zoo? Get ready to outsmart your captors and embark on a wild adventure in Zoo Escape!"
    },
    {
      "id": 44,
      "url": "/games/AnimalShadow/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Animal Shadow",
      "datasrc": "/games/AnimalShadow/icons/300x300.jpg",
      "logo": "/games/AnimalShadow/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "The objective of the game is to observe and identify different animal shadows, improving observation and language skills while having fun."
    },
    {
      "id": 45,
      "url": "/games/Apples/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Apples",
      "datasrc": "/games/Apples/icons/300x300.jpg",
      "logo": "/games/Apples/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Click the screen to launch apples and eliminate three and more apples of the samecolor! The apples keep falling, don't let them reach the bottom of the screen!Destroy all the apples!"
    },
    {
      "id": 46,
      "url": "/games/Battleship/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Battleship",
      "datasrc": "/games/Battleship/icons/300x300.jpg",
      "logo": "/games/Battleship/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "Tap the screen to control the position of the ship! You will take turns with theenemy to fire missiles at each other's ships! Use your strategy to hide your ship anddefeat all enemy ships first to win!"
    },
    {
      "id": 47,
      "url": "/games/BlockDefender/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Block Defender",
      "datasrc": "/games/BlockDefender/icons/300x300.jpg",
      "logo": "/games/BlockDefender/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "Spend coins to place bricks in the proper position and synthesize the same bricksAs the speed increases the butterflies attack more fiercely! Synthesize more bricks to defend the garden!"
    },
    {
      "id": 48,
      "url": "/games/BouncingBalls/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Bouncing Balls",
      "datasrc": "/games/BouncingBalls/icons/300x300.jpg",
      "logo": "/games/BouncingBalls/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Click to launch the ball and break the squares! Try to get bonus points and balls! lfa square touches the floor you lose!"
    },
    {
      "id": 49,
      "url": "/games/CardAttack/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Card Attack",
      "datasrc": "/games/CardAttack/icons/300x300.jpg",
      "logo": "/games/CardAttack/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "By moving cards, you can choose to strengthen your hero, or fight against soldiers! r nInfiltrate the castle now to fight for the ultimate fortune!"
    },
    {
      "id": 50,
      "url": "/games/Chess/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Chess",
      "datasrc": "/games/Chess/icons/300x300.jpg",
      "logo": "/games/Chess/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Tap the screen to move your chess pieces! Supports multi-player! Come and have a r ntense and exciting chess duel with your mates!"
    },
    {
      "id": 51,
      "url": "/games/\"Choose Gravity\"/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Choose  Gravity",
      "datasrc": "/games/Choose Gravity/icons/300x300.jpg",
      "logo": "/games/Choose Gravity/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4.5,
      "synopsis": "In Choose Gravity, players control a character through a series of levels filled with obstacles and challenges. The key mechanic is the ability to choose the direction of gravity, allowing the player to walk on walls, ceilings, and even float in mid-air. This flexibility in movement gives players unprecedented control over their environment and enables them to find creative solutions to intricate puzzles. r n    Levels are designed to test players' skills and ingenuity. Some puzzles require precise timing and coordination, while others challenge players to think strategically about how they manipulate gravity to progress. The game's difficulty gradually increases as players progress, ensuring a constant sense of challenge and accomplishment."
    },
    {
      "id": 52,
      "url": "/games/\"Christmas Match3\"/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Christmas  Match3",
      "datasrc": "/games/Christmas Match3/icons/300x300.jpg",
      "logo": "/games/Christmas Match3/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "The game is beautifully designed with a festive Christmas theme, featuring vibrant graphics and cheerful holiday music that immerse players in the spirit of the season. r n    Variety of Levels: With numerous levels to choose from, each offering unique challenges and obstacles, players can enjoy endless entertainment and a fresh experience with every new game."
    },
    {
      "id": 53,
      "url": "/games/\"Circle Flip\"/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Circle  Flip",
      "datasrc": "/games/Circle Flip/icons/300x300.jpg",
      "logo": "/games/Circle Flip/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Players who enjoy fast-paced and challenging games will find Circle Flip to be a thrilling experience. The game's addictive gameplay and engaging graphics keep players coming back for more, as they strive to survive longer and collect more diamonds. The increasing difficulty and changing patterns add to the challenge, making Circle Flip a game that is both fun and challenging."
    },
    {
      "id": 54,
      "url": "/games/CleanTheOcean/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Clean The Ocean",
      "datasrc": "/games/CleanTheOcean/icons/300x300.jpg",
      "logo": "/games/CleanTheOcean/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Collect a sufficient amount of marine debris within the specified time to get points! r nRemember not to catch fish, it will reduce your points!"
    },
    {
      "id": 55,
      "url": "/games/\"Cold Miner\"/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Cold  Miner",
      "datasrc": "/games/Cold Miner/icons/300x300.jpg",
      "logo": "/games/Cold Miner/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Cold Miner features beautiful graphics and realistic environments that bring the icy mines to life. The game's controls are intuitive and easy to master, allowing players to quickly become familiar with the mining process. Additionally, the game offers a variety of tools and equipment that can be used to improve mining efficiency and increase the chances of finding rare and valuable resources."
    },
    {
      "id": 56,
      "url": "/games/\"Color Tower\"/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Color  Tower",
      "datasrc": "/games/Color Tower/icons/300x300.jpg",
      "logo": "/games/Color Tower/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Color Tower features a vibrant color scheme with blocks of various hues, creating a visually appealing and exciting gaming environment."
    },
    {
      "id": 57,
      "url": "/games/ConnectMatch/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Connect Match",
      "datasrc": "/games/ConnectMatch/icons/300x300.jpg",
      "logo": "/games/ConnectMatch/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4,
      "synopsis": "Slide the screen to connect dots of the same color and eliminate them! Reach your r ngoal in the required number of moves!"
    },
    {
      "id": 58,
      "url": "/games/CrossyChicken/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Crossy Chicken",
      "datasrc": "/games/CrossyChicken/icons/300x300.jpg",
      "logo": "/games/CrossyChicken/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Tap the screen to move the chick forward! Swipe the screen to change the directionof movement! Let the chick avoid all obstacles and reach the finish line before theplane arrives!"
    },
    {
      "id": 59,
      "url": "/games/FindMyDog/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Find My Dog",
      "datasrc": "/games/FindMyDog/icons/300x300.jpg",
      "logo": "/games/FindMyDog/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Find your puppy among the dog piles in no time! You can share or save the cutest puppy pictures you think!"
    },
    {
      "id": 60,
      "url": "/games/FishShip/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Fish Ship",
      "datasrc": "/games/FishShip/icons/300x300.jpg",
      "logo": "/games/FishShip/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4,
      "synopsis": "FISHNSHIP is a business simulation game. Players will play the role of a captain, fishing in the vast sea, managing fishing boats, and developing their own fishing empire. Through strategic fishing operations and resource management, players can experience the real fun of fishery management in the game."
    },
    {
      "id": 61,
      "url": "/games/\"Flappy Ball\"/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Flappy  Ball",
      "datasrc": "/games/Flappy Ball/icons/300x300.jpg",
      "logo": "/games/Flappy Ball/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Flappy Ball is an engaging and addictive arcade-style game that draws inspiration from the popular Flappy Bird franchise. This fast-paced challenge focuses on precise control and quick reflexes, testing your ability to navigate a ball through narrow passages and obstacle courses."
    },
    {
      "id": 62,
      "url": "/games/FlappyDove/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Flappy Dove",
      "datasrc": "/games/FlappyDove/icons/300x300.jpg",
      "logo": "/games/FlappyDove/icons/300x300.jpg",
      "tag": "hot",
      "rating": 3.5,
      "synopsis": "Maneuver the dove up and down by tapping the screen! Keep moving and don't hitthe obstacles on the way! Note that hitting the obstacles will end the game! Go formore points!"
    },
    {
      "id": 63,
      "url": "/games/\"Halloween Bubble Shooter\"/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Halloween  Bubble  Shooter",
      "datasrc": "/games/Halloween Bubble Shooter/icons/300x300.jpg",
      "logo": "/games/Halloween Bubble Shooter/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Halloween Bubble Shooter is a must-play for anyone who loves bubble shooters and the Halloween holiday. Whether you're looking for a quick game to pass the time or a challenging puzzle to solve, this game offers something for everyone. So, grab your cannon and get ready to pop some bubbles as you embark on this spooky yet exciting adventure!"
    },
    {
      "id": 64,
      "url": "/games/Halloween2048/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Halloween2048",
      "datasrc": "/games/Halloween2048/icons/300x300.jpg",
      "logo": "/games/Halloween2048/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Control the arrow keys to synthesize Halloween boxes with the same number andgain points! Use your strategy to synthesize up to 2048!"
    },
    {
      "id": 65,
      "url": "/games/HalloweenShooter/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Halloween Shooter",
      "datasrc": "/games/HalloweenShooter/icons/300x300.jpg",
      "logo": "/games/HalloweenShooter/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Tap the screen to launch pumpkins and eliminate three or more pumpkins of thesame color! Pumpkins keep coming out, don't let them reach the bottom of thescreen! Eliminate all the pumpkins!"
    },
    {
      "id": 66,
      "url": "/games/HexaMerge/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Hexa Merge",
      "datasrc": "/games/HexaMerge/icons/300x300.jpg",
      "logo": "/games/HexaMerge/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Tap the screen to swap the numbered squares and place them on the board! Yourgoal is to merge three and more identical numbers! The bigger the number youmerge, the more points you get!"
    },
    {
      "id": 67,
      "url": "/games/\"Hot Jewels\"/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Hot  Jewels",
      "datasrc": "/games/Hot Jewels/icons/300x300.jpg",
      "logo": "/games/Hot Jewels/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Hot Jewels have been loved and praised by a large number of players. Players generally believe that this game is simple and easy to learn, but it is also challenging. The gem elimination gameplay in the game is very interesting and irresistible. Meanwhile, the exquisite graphics and rich sound effects also add a lot of color to the game. Many players have expressed that they will keep an eye on the updated content of Hot Jewels and look forward to challenging more interesting levels. r n    In short, Hot Jewels is a gem elimination game worth trying out. Whether you are a casual player or a challenge enthusiast, you can find fun and a sense of achievement in this game. Come and join the world of Hot Jewels!"
    },
    {
      "id": 68,
      "url": "/games/\"Kids True Colors\"/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Kids  True  Colors",
      "datasrc": "/games/Kids True Colors/icons/300x300.jpg",
      "logo": "/games/Kids True Colors/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "The gameplay of Kids True Colors is simple yet engaging. Players will be introduced to a variety of colorful scenes and challenges, each focusing on a different aspect of color recognition and learning. Through interactive activities such as painting, sorting, and matching, kids will have the opportunity to explore different colors, understand their properties, and create their own unique works of art."
    },
    {
      "id": 69,
      "url": "/games/KingHit/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " King Hit",
      "datasrc": "/games/KingHit/icons/300x300.jpg",
      "logo": "/games/KingHit/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Tap left or right side of the screen to punch! Watch out from the pallets though! Come on be the Hit King!"
    },
    {
      "id": 70,
      "url": "/games/KnightShot/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Knight Shot",
      "datasrc": "/games/KnightShot/icons/300x300.jpg",
      "logo": "/games/KnightShot/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Drag the screen to control the direction of the knight's attack, collide the monstersto make them fall out of the platform and get coins! Use the coins to build morebuildings!"
    },
    {
      "id": 71,
      "url": "/games/MoreBricks/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " More Bricks",
      "datasrc": "/games/MoreBricks/icons/300x300.jpg",
      "logo": "/games/MoreBricks/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4,
      "synopsis": "Maneuver your character to occupy the bricks by controlling the arrow keys! Youcan also capture other people's bricks! Bring your partner to PK with you! Whoevercaptures the most bricks is the winner!"
    },
    {
      "id": 72,
      "url": "/games/\"Mummy Candies\"/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Mummy  Candies",
      "datasrc": "/games/Mummy Candies/icons/300x300.jpg",
      "logo": "/games/Mummy Candies/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 3.5,
      "synopsis": "Mummy Candies is easy to pick up but difficult to master, providing endless hours of entertainment for players of all ages. Whether you're a casual gamer looking for a fun way to pass the time or a puzzle enthusiast seeking a challenging new game, Mummy Candies is sure to satisfy your sweet tooth and your puzzle-solving skills."
    },
    {
      "id": 73,
      "url": "/games/NumberSnake/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Number Snake",
      "datasrc": "/games/NumberSnake/icons/300x300.jpg",
      "logo": "/games/NumberSnake/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4,
      "synopsis": "Long press and drag the number snake to punch through the bricks! Pick up morenumber to hit bricks with numbers smaller than you! The higher the number ofbricks you break, the more points you get!"
    },
    {
      "id": 74,
      "url": "/games/ParkingJam/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Parking Jam",
      "datasrc": "/games/ParkingJam/icons/300x300.jpg",
      "logo": "/games/ParkingJam/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4,
      "synopsis": "Drag the vehicles that are blocked in the parking lot, drive all the vehicles out of theparking lot without collision, and get a lot of rewards after success!"
    },
    {
      "id": 75,
      "url": "/games/PerfectMine/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Perfect Mine",
      "datasrc": "/games/PerfectMine/icons/300x300.jpg",
      "logo": "/games/PerfectMine/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Click on the workers and send them to mine. Upgrading workers' equipment andmanufacturing auxiliary tools can greatly increase the output efficiency of goldmines!"
    },
    {
      "id": 76,
      "url": "/games/\"Quick Dice\"/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Quick  Dice",
      "datasrc": "/games/Quick Dice/icons/300x300.jpg",
      "logo": "/games/Quick Dice/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Quick Dice is a fun and exciting dice game that offers a fast-paced gaming experience filled with strategy and luck. Whether you're playing with friends or challenging yourself, Quick Dice provides endless entertainment and excitement. Grab your dice and get ready to roll in this thrilling game of strategy and chance!"
    },
    {
      "id": 77,
      "url": "/games/SaveTheDog/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Save The Dog",
      "datasrc": "/games/SaveTheDog/icons/300x300.jpg",
      "logo": "/games/SaveTheDog/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Avoid the dog from being attacked by bees by drawing lines. We look forward toyour unique method, come and try it!"
    },
    {
      "id": 78,
      "url": "/games/SlimeInvader/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Slime Invader",
      "datasrc": "/games/SlimeInvader/icons/300x300.jpg",
      "logo": "/games/SlimeInvader/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Slide the turret handle and adjust the angle to eliminate the incoming peamonsters. Choose different attribute stacks every time you upgrade, you willbecome super powerful!"
    },
    {
      "id": 79,
      "url": "/games/Snakeland/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Snakeland",
      "datasrc": "/games/Snakeland/icons/300x300.jpg",
      "logo": "/games/Snakeland/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 5,
      "synopsis": "Control the arrow keys to make the snake eat the gold coins on the island! Avoidobstacles and head to the door that leads to the next level! Note that the moregold coins you eat, the longer the snake's body will grow!"
    },
    {
      "id": 80,
      "url": "/games/\"Tank Defender\"/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Tank  Defender",
      "datasrc": "/games/Tank Defender/icons/300x300.jpg",
      "logo": "/games/Tank Defender/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Tank Defender is an engaging and thrilling defense game that offers players an exciting challenge. Whether you're a fan of defense games or simply looking for a new and exciting gaming experience, Tank Defender is sure to delight you. So, get ready to take control of your tank and defend your country from the invading forces in this thrilling adventure!"
    },
    {
      "id": 81,
      "url": "/games/TapSupermarket/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Tap Supermarket",
      "datasrc": "/games/TapSupermarket/icons/300x300.jpg",
      "logo": "/games/TapSupermarket/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4,
      "synopsis": "Tap to replenish supermarket items and stock! Tap the cash register to speed up thequeue time for customers! You can also spend coins to add more shelves andcashiers!"
    },
    {
      "id": 82,
      "url": "/games/Ten/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Ten",
      "datasrc": "/games/Ten/icons/300x300.jpg",
      "logo": "/games/Ten/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Control the arrow keys to synthesize the same number of squares and gain points!Each swipe brings up a new square! Come and synthesize the number 10!"
    },
    {
      "id": 83,
      "url": "/games/TreasureOfSea/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Treasure Of Sea",
      "datasrc": "/games/TreasureOfSea/icons/300x300.jpg",
      "logo": "/games/TreasureOfSea/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 3.5,
      "synopsis": "Click on the lit grid around to move the ship. Pay attention to other ships that areconstantly approaching, and choose a good attack direction to defeat them at anytime!"
    },
    {
      "id": 84,
      "url": "/games/VirusFighter/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Virus Fighter",
      "datasrc": "/games/VirusFighter/icons/300x300.jpg",
      "logo": "/games/VirusFighter/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4,
      "synopsis": "Slide the turret handle and adjust the angle to eliminate the incoming peamonsters. Choose different attribute stacks every time you upgrade, you willbecome super powerful!"
    },
    {
      "id": 85,
      "url": "/games/\"Zombie Shooter\"/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Zombie  Shooter",
      "datasrc": "/games/Zombie Shooter/icons/300x300.jpg",
      "logo": "/games/Zombie Shooter/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Zombie Shooter is an action-packed shooting game developed by Sigma Team Inc. that immerses players in a thrilling zombie-infested world. The game offers an intense shooting experience as players face off against hordes of undead enemies, using a wide variety of weapons and equipment to survive and defeat the zombie threat."
    },
    {
      "id": 86,
      "url": "/games/ZombieBuster/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Zombie Buster",
      "datasrc": "/games/ZombieBuster/icons/300x300.jpg",
      "logo": "/games/ZombieBuster/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Click anywhere on the screen to control the shooting direction of the character! Defeat all the zombies before the ammo runs out!"
    },
    {
      "id": 87,
      "url": "/games/\"3D Bottle Shooter\"/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": "3 D  Bottle  Shooter",
      "datasrc": "/games/3D Bottle Shooter/icons/300x300.jpg",
      "logo": "/games/3D Bottle Shooter/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Try to shoot all of the bottles in front of you before you run out of bullets. The better your accuracy the more stars you will earn. In each level you have a limited amount of bullets and a time limit, so keep an eye on both as you fire away your gun as you try to smash all of the bottles in this fun 3d shooting game."
    },
    {
      "id": 88,
      "url": "/games/\"99 Balls\"/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": "99  Balls",
      "datasrc": "/games/99 Balls/icons/300x300.jpg",
      "logo": "/games/99 Balls/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "99 Balls Evo is the latest and best version of the popular 99 Balls concept. This game will have you hooked in no time!"
    },
    {
      "id": 89,
      "url": "/games/Anti-VirusGame/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Anti- Virus Game",
      "datasrc": "/games/Anti-VirusGame/icons/300x300.jpg",
      "logo": "/games/Anti-VirusGame/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Anti-Virus is a casual puzzle game where players need to destroy viruses using antibodies. The game features multiple levels and obstacles, challenging the player's logic and strategic thinking skills."
    },
    {
      "id": 90,
      "url": "/games/\"Block Spin\"/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Block  Spin",
      "datasrc": "/games/Block Spin/icons/300x300.jpg",
      "logo": "/games/Block Spin/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "\"Block Spin\" is a puzzle game where you must rotate blocks to create a complete line. The game features challenging levels, addictive gameplay, and simple controls that make it easy to pick up and play."
    },
    {
      "id": 91,
      "url": "/games/BottleShootGD/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Bottle Shoot G D",
      "datasrc": "/games/BottleShootGD/icons/300x300.jpg",
      "logo": "/games/BottleShootGD/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 3.5,
      "synopsis": "Bottle Shoot is a simple and addictive game where players must shoot bottles and earn points. The game features colorful graphics, easy-to-use controls, and a variety of levels to challenge players."
    },
    {
      "id": 92,
      "url": "/games/\"Cats Love Cake\"/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Cats  Love  Cake",
      "datasrc": "/games/Cats Love Cake/icons/300x300.jpg",
      "logo": "/games/Cats Love Cake/icons/300x300.jpg",
      "tag": "hot",
      "rating": 3.5,
      "synopsis": "\"Cats Love Cake\" is a casual puzzle game where you must help cute cats collect cakes. With its addictive gameplay and colorful graphics, \"Cats Love Cake\" is a great choice for players looking for a fun and challenging gaming experience."
    },
    {
      "id": 93,
      "url": "/games/CrossyCat/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Crossy Cat",
      "datasrc": "/games/CrossyCat/icons/300x300.jpg",
      "logo": "/games/CrossyCat/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 5,
      "synopsis": "\"Crossy Cat\" is a casual arcade game where players control a cute cat to cross a busy road filled with obstacles and traffic. The goal is to safely guide the cat across the road without getting hit by cars or falling into the water. With its simple controls and addictive gameplay, \"Crossy Cat\" is suitable for players of all ages."
    },
    {
      "id": 94,
      "url": "/games/\"Crowd Defense\"/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Crowd  Defense",
      "datasrc": "/games/Crowd Defense/icons/300x300.jpg",
      "logo": "/games/Crowd Defense/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "Defend your position against the enemy waves. Unlock more powerful weapons to clear the massive crowd coming at you! Enhance your arsenal after beating the world boss! This next gen mobile game is for you!"
    },
    {
      "id": 95,
      "url": "/games/\"Gun Of Doom\"/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Gun  Of  Doom",
      "datasrc": "/games/Gun Of Doom/icons/300x300.jpg",
      "logo": "/games/Gun Of Doom/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "In 20XX, humans were overwhelmed by an unknown superparasitic plant, and only a few humans with natural antibodies survived. In order to find survival supplies, the survivors had to take up arms to fight the parasites."
    },
    {
      "id": 96,
      "url": "/games/\"Lava Bird Poki\"/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Lava  Bird  Poki",
      "datasrc": "/games/Lava Bird Poki/icons/300x300.jpg",
      "logo": "/games/Lava Bird Poki/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "\"Lava Bird\" is a challenging arcade game where players control a lava bird and navigate through an obstacle course filled with hazards. The objective is to survive as long as possible while collecting coins to unlock new characters and power-ups."
    },
    {
      "id": 97,
      "url": "/games/\"Stick Race\"/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Stick  Race",
      "datasrc": "/games/Stick Race/icons/300x300.jpg",
      "logo": "/games/Stick Race/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Avoid the obstacles and gaps to win the race. Show your opponents who is the boss! How many races can you win?"
    },
    {
      "id": 98,
      "url": "/games/NumBreaker/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Num Breaker",
      "datasrc": "/games/NumBreaker/icons/300x300.jpg",
      "logo": "/games/NumBreaker/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4,
      "synopsis": "Use the right number of bullets to destroy the ball before it falls. The more balls disappear, the higher the score you can get. Challenge hundreds of levels."
    },
    {
      "id": 99,
      "url": "/games/RatsCooking/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Rats Cooking",
      "datasrc": "/games/RatsCooking/icons/300x300.jpg",
      "logo": "/games/RatsCooking/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Rats Cooking is a cooking game where you need to help the rat chef cook delicious food. With various ingredients and utensils, the game offers a challenging and fun experience for players of all ages. Play Rats Cooking now and become a master chef!"
    },
    {
      "id": 100,
      "url": "/games/RedBallForever2/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Red Ball Forever2",
      "datasrc": "/games/RedBallForever2/icons/300x300.jpg",
      "logo": "/games/RedBallForever2/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Red Ball Forever 2 is a 2D platform game that follows the new adventures of the cheerful ball first appeared in last year's Red Ball Forever. Complete all the levels, collect as many stars as you can, and have fun!"
    },
    {
      "id": 101,
      "url": "/games/RunIntoDeath/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Run Into Death",
      "datasrc": "/games/RunIntoDeath/icons/300x300.jpg",
      "logo": "/games/RunIntoDeath/icons/300x300.jpg",
      "tag": "hot",
      "rating": 3.5,
      "synopsis": "Run Into Death is a thrilling endless runner game where you need to navigate through a dangerous obstacle course while avoiding death. With fast-paced gameplay and challenging levels, the game offers a exciting experience for players of all ages. Play Run Into Death now and see how far you can run!"
    },
    {
      "id": 102,
      "url": "/games/\"Shooter Rush\"/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Shooter  Rush",
      "datasrc": "/games/Shooter Rush/icons/300x300.jpg",
      "logo": "/games/Shooter Rush/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4.5,
      "synopsis": "Shooter Rush is a first-person shooter game where you need to survive and destroy the enemies. With various weapons and maps, the game offers a thrilling and addictive experience for players of all ages. Play Shooter Rush now and become the best shooter!"
    },
    {
      "id": 103,
      "url": "/games/SpaceTrip/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Space Trip",
      "datasrc": "/games/SpaceTrip/icons/300x300.jpg",
      "logo": "/games/SpaceTrip/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Space Trip is a space shooting game where you need to destroy the enemies and asteroids. With various weapons and upgrades, the game offers a challenging and addictive experience for players of all ages. Play Space Trip now and explore the galaxy!"
    },
    {
      "id": 104,
      "url": "/games/StrikeSquad/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Strike Squad",
      "datasrc": "/games/StrikeSquad/icons/300x300.jpg",
      "logo": "/games/StrikeSquad/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Reload your weapon and get ready to shoot some enemies as they come at you from all sides or you find them hiding in rooms! Collect more coins with each mission you complete and unlock new weapons and keep going!"
    },
    {
      "id": 105,
      "url": "/games/\"Surfing Down\"/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Surfing  Down",
      "datasrc": "/games/Surfing Down/icons/300x300.jpg",
      "logo": "/games/Surfing Down/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "\"Surfing Down\" is a 3D extreme sports game. Players will slide down the steepest and most dangerous mountains, experiencing the thrill of speed and danger. The game features a variety of different tracks and environments, each with its own unique challenges and obstacles. Players must use their skills and reflexes to navigate through the tracks and avoid obstacles to reach the bottom safely."
    },
    {
      "id": 106,
      "url": "/games/\"Tactical Squad\"/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Tactical  Squad",
      "datasrc": "/games/Tactical Squad/icons/300x300.jpg",
      "logo": "/games/Tactical Squad/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "\"Tactical Squad\" is a strategy game where players command a squad of soldiers and engage in battles. The game features realistic graphics and challenging gameplay that will keep players engaged for hours."
    },
    {
      "id": 107,
      "url": "/games/TinyArcher/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Tiny Archer",
      "datasrc": "/games/TinyArcher/icons/300x300.jpg",
      "logo": "/games/TinyArcher/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Find magical characters, fight various enemies, unlock magic arrows and amazing abilities. Rely on your bow and arrow skills to survive! Defend your tower, defeat countless goblin armies and save the situation! Join Tiny Archers for the ultimate bow and arrow adventure!"
    },
    {
      "id": 108,
      "url": "/games/WheelieBiker/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Wheelie Biker",
      "datasrc": "/games/WheelieBiker/icons/300x300.jpg",
      "logo": "/games/WheelieBiker/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Wheelie Biker is a side-scrolling obstacle course game. Ride the bike, score points by pulling wheelies, and reach the finish line with the score bar being full."
    },
    {
      "id": 109,
      "url": "/games/4InaRowClassic/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": "4 Ina Row Classic",
      "datasrc": "/games/4InaRowClassic/icons/300x300.jpg",
      "logo": "/games/4InaRowClassic/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "4 in a Row is a classic board game where you need to place four pieces of your color in a row to win. With different game modes and levels of difficulty, the game offers a challenging and fun experience for players of all ages. Play 4 in a Row now and show your strategic skills!"
    },
    {
      "id": 110,
      "url": "/games/AmazingKlondikeSolitaire/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Amazing Klondike Solitaire",
      "datasrc": "/games/AmazingKlondikeSolitaire/icons/300x300.jpg",
      "logo": "/games/AmazingKlondikeSolitaire/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "amazing solitaire is a very fun and entertaining card game that is one of yigames' selected recommended games"
    },
    {
      "id": 111,
      "url": "/games/ClassicSolitaire/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Classic Solitaire",
      "datasrc": "/games/ClassicSolitaire/icons/300x300.jpg",
      "logo": "/games/ClassicSolitaire/icons/300x300.jpg",
      "tag": "hot",
      "rating": 3.5,
      "synopsis": "\"Classic Solitaire\" is a card game that has been enjoyed for generations. Players need to stack cards in ascending or descending order to clear the board. The game features simple rules and addictive gameplay that will keep players entertained for hours."
    },
    {
      "id": 112,
      "url": "/games/\"Ludo Hero\"/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Ludo  Hero",
      "datasrc": "/games/Ludo Hero/icons/300x300.jpg",
      "logo": "/games/Ludo Hero/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "\"Ludo Hero\" is a classic board game where you roll the dice and move your pieces around the board. The game features multiple game modes, challenging opponents, and the ability to play with friends."
    },
    {
      "id": 113,
      "url": "/games/MahjongFirefly/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Mahjong Firefly",
      "datasrc": "/games/MahjongFirefly/icons/300x300.jpg",
      "logo": "/games/MahjongFirefly/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Content Introduction and Highlights for \"mahjong firefly\" Game: In this captivating game, players are immersed in a world of beautiful mahjong tiles and fireflies. The objective is to match and remove tiles to create combinations and clear the board. With its addictive gameplay and challenging levels, \"mahjong firefly\" offers hours of entertainment. One of the highlights is the stunning graphics and animations that bring the game to life. The fireflies add a magical touch, creating a visually appealing and immersive experience. Players can enjoy the soothing background music while showcasing their strategic thinking and problem-solving skills."
    },
    {
      "id": 114,
      "url": "/games/\"Solitaire Reverse\"/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Solitaire  Reverse",
      "datasrc": "/games/Solitaire Reverse/icons/300x300.jpg",
      "logo": "/games/Solitaire Reverse/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Solitaire Reverse is a single-player card game. In this game, the player tries to rearrange the cards in the deck in the correct order. With simple rules and challenging levels, Solitaire Reverse is a great pastime for anyone."
    },
    {
      "id": 115,
      "url": "/games/\"Tic Tac Toe 3\"/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Tic  Tac  Toe 3",
      "datasrc": "/games/Tic Tac Toe 3/icons/300x300.jpg",
      "logo": "/games/Tic Tac Toe 3/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "\"Tic Tac Toe 3\" is a classic strategy game where two players take turns marking X's and O's on a 3x3 grid. The goal is to be the first to get three of your marks in a row. With its simple rules and addictive gameplay, \"Tic Tac Toe 3\" is a great choice for quick, casual gaming sessions."
    },
    {
      "id": 116,
      "url": "/games/BubbleMatch/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Bubble Match",
      "datasrc": "/games/BubbleMatch/icons/300x300.jpg",
      "logo": "/games/BubbleMatch/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "“Bubble Match” is a casual puzzle game where players need to match three or more bubbles of the same color. With simple controls and addictive gameplay, the game is suitable for players of all ages. There are many different levels in the game, each with increasing difficulty, challenging players’ logic thinking and strategic planning."
    },
    {
      "id": 117,
      "url": "/games/\"Cat Room Blast\"/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Cat  Room  Blast",
      "datasrc": "/games/Cat Room Blast/icons/300x300.jpg",
      "logo": "/games/Cat Room Blast/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Cat Room Blast is a puzzle game where players must clear rooms of cats by matching three or more cats of the same color. The game features multiple levels and challenges, as well as power-ups and bonuses to help players progress. With its cute and colorful graphics, Cat Room Blast is a fun and addictive game for all ages."
    },
    {
      "id": 118,
      "url": "/games/CrystalBlast/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Crystal Blast",
      "datasrc": "/games/CrystalBlast/icons/300x300.jpg",
      "logo": "/games/CrystalBlast/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "“Crystal Blast” is a casual puzzle game where players need to connect three or more crystals of the same color to eliminate them. With simple controls and addictive gameplay, the game is suitable for players of all ages. There are many different levels in the game, each with increasing difficulty, challenging players’ logic thinking and strategic planning."
    },
    {
      "id": 119,
      "url": "/games/IceCreamFrenzy/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Ice Cream Frenzy",
      "datasrc": "/games/IceCreamFrenzy/icons/300x300.jpg",
      "logo": "/games/IceCreamFrenzy/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Help Lisa to run her own ice cream shop in the three different stages of this great online time management game. Upgrade the equipment and unlock all achievements."
    },
    {
      "id": 120,
      "url": "/games/JewelMatch/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Jewel Match",
      "datasrc": "/games/JewelMatch/icons/300x300.jpg",
      "logo": "/games/JewelMatch/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Jewel Match is a fun Match 3 game, which is suitable for people of all ages. Swap the location of the jewels to eliminate three or more identical squares. Of course, you will have to complete the assigned tasks for each level. How many levels can you pass?"
    },
    {
      "id": 121,
      "url": "/games/mahjong_cards0.2.52/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": "Mahjong_cards0.2.52",
      "datasrc": "/games/mahjong_cards0.2.52/icons/300x300.jpg",
      "logo": "/games/mahjong_cards0.2.52/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4,
      "synopsis": "Mahjong Cards is a card game that originated in China. The game is played with a set of 144 tiles based on Chinese characters and symbols. The objective of the game is to form winning combinations of tiles. Mahjong Cards is a popular game that is enjoyed by people all over the world."
    },
    {
      "id": 122,
      "url": "/games/MahjongPyramids/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Mahjong Pyramids",
      "datasrc": "/games/MahjongPyramids/icons/300x300.jpg",
      "logo": "/games/MahjongPyramids/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "\"Mahjong Pyramids\" is a puzzle game where players need to match and remove tiles with the same pattern from a pyramid. The game features challenging levels and addictive gameplay that will keep players entertained for hours."
    },
    {
      "id": 123,
      "url": "/games/\"Pet Party Columns\"/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Pet  Party  Columns",
      "datasrc": "/games/Pet Party Columns/icons/300x300.jpg",
      "logo": "/games/Pet Party Columns/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "\"Pet Party Columns\" is a fun and addictive puzzle game where you need to match and eliminate columns of cute pets. The goal is to clear all the pets on the screen by making combinations of three or more of the same kind. The game features various challenges and levels, as well as power-ups to help you along the way."
    },
    {
      "id": 124,
      "url": "/games/StoneOThePharaoh/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Stone O The Pharaoh",
      "datasrc": "/games/StoneOThePharaoh/icons/300x300.jpg",
      "logo": "/games/StoneOThePharaoh/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "\"STONE OF THE PHARAOH\" is a puzzle game where players need to match and remove tiles with the same pattern from a pyramid. The game features challenging levels and addictive gameplay that will keep players entertained for hours."
    },
    {
      "id": 125,
      "url": "/games/SushiMatching/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Sushi Matching",
      "datasrc": "/games/SushiMatching/icons/300x300.jpg",
      "logo": "/games/SushiMatching/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Welcome to Sushi Time! Let me teach you how to prepare your first sushi. You have to ensure that every customer is served not only to his satisfaction, but also as quickly as possible. As the game progresses, the number of customers grows, and so does the number of dishes they order. Be careful not to mix up your recipes. Are you ready?"
    },
    {
      "id": 126,
      "url": "/games/TheSorcerer/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " The Sorcerer",
      "datasrc": "/games/TheSorcerer/icons/300x300.jpg",
      "logo": "/games/TheSorcerer/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4,
      "synopsis": "\"The Sorcerer\" is a role-playing game where players take on the role of a powerful sorcerer and explore a fantasy world filled with magic and adventure. Players can customize their sorcerer with unique spells and abilities, and embark on quests to defeat enemies and uncover the secrets of the world.\n"
    },
    {
      "id": 127,
      "url": "/games/\"Tingly Game\"/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Tingly  Game",
      "datasrc": "/games/Tingly Game/icons/300x300.jpg",
      "logo": "/games/Tingly Game/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "\"Tingly Game\" is a fun and addictive bubble shooter game where you must shoot bubbles to match and eliminate them. With its colorful graphics and easy-to-learn gameplay, \"Bubbles Cool\" is a great choice for players of all ages looking for a casual and enjoyable gaming experience."
    },
    {
      "id": 128,
      "url": "/games/TinglyGamemajiang/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Tingly Gamemajiang",
      "datasrc": "/games/TinglyGamemajiang/icons/300x300.jpg",
      "logo": "/games/TinglyGamemajiang/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "\"TinglyGamemajiang\" is a tile-matching game based on the classic Chinese game of mahjong. Players connect matching tiles to clear the board and earn points. With its simple gameplay and addictive mechanics, the game offers hours of entertainment for players of all ages."
    },
    {
      "id": 129,
      "url": "/games/\"Bubble Pop Adventures\"/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Bubble  Pop  Adventures",
      "datasrc": "/games/Bubble Pop Adventures/icons/300x300.jpg",
      "logo": "/games/Bubble Pop Adventures/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Mushroom head hubble-bubble dragon adventure, the player 's mission is to help the mushroom head toll-gate task, only need to eliminate all levels within the bubble ball.Each level are changeable, launch bubble ball reasonable use eliminate all bubble ball!"
    },
    {
      "id": 130,
      "url": "/games/\"Caveman Hunt\"/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Caveman  Hunt",
      "datasrc": "/games/Caveman Hunt/icons/300x300.jpg",
      "logo": "/games/Caveman Hunt/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Throw the caveman as far as possible and chase the mammoth! Collect coins and use them to buy power-ups!"
    },
    {
      "id": 131,
      "url": "/games/\"Christmas Hop\"/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Christmas  Hop",
      "datasrc": "/games/Christmas Hop/icons/300x300.jpg",
      "logo": "/games/Christmas Hop/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Help Santa and the other unlock-able characters down the mountain in this fun block hopping game. Jump down from block to block avoiding spikes, lava and other deadly objects. Safely land on the next platform below to increase your score. Keep hopping down, collecting coins and attempting to beat your friends high scores."
    },
    {
      "id": 132,
      "url": "/games/\"Crashy Cat\"/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Crashy  Cat",
      "datasrc": "/games/Crashy Cat/icons/300x300.jpg",
      "logo": "/games/Crashy Cat/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Help save the cat by dropping it down to the bottom platform. Avoid the deadly obstacles while you attempt to collect all 3 stars in each level. Keep crashing down until you complete all of the levels in this fun online puzzle game."
    },
    {
      "id": 133,
      "url": "/games/CyberBasket/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Cyber Basket",
      "datasrc": "/games/CyberBasket/icons/300x300.jpg",
      "logo": "/games/CyberBasket/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Cyber Basket is a challenging new skill game that tests your aim and quick-thinking. Dodge obstacles and harness a series of air guns to dunk a constantly falling basketball through the hoops. If your ball hits an obstacle it game over. You will want to play again and again to hone your skills and improve your score."
    },
    {
      "id": 134,
      "url": "/games/\"Dunk Hit\"/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Dunk  Hit",
      "datasrc": "/games/Dunk Hit/icons/300x300.jpg",
      "logo": "/games/Dunk Hit/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 5,
      "synopsis": "Dunk Hit Basketball is ball potting timing game, you need to pot the ball before the timer runs out. Push the ball at right time to score. Timing is enough to bear 1 mistake for initial points, but it will not be enough for later rounds."
    },
    {
      "id": 135,
      "url": "/games/\"Explode Ballz\"/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Explode  Ballz",
      "datasrc": "/games/Explode Ballz/icons/300x300.jpg",
      "logo": "/games/Explode Ballz/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Explode Ballz is a fun arcade game. The goal of the game is to match balls with the same color. You can get bigger balls and blow them up in order to get a higher score."
    },
    {
      "id": 136,
      "url": "/games/Fishing/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Fishing",
      "datasrc": "/games/Fishing/icons/300x300.jpg",
      "logo": "/games/Fishing/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Let's go fishing!"
    },
    {
      "id": 137,
      "url": "/games/\"Geometry Jump\"/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Geometry  Jump",
      "datasrc": "/games/Geometry Jump/icons/300x300.jpg",
      "logo": "/games/Geometry Jump/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Geometry Dash, the cool plattform reaction game, is back with new challenging levels. Jump with perfect timing to overcome traps and obstacles and reach the end of every level in order to unlock the next one. How many tries is it gonna take for you to finish each stage? Find out now! Enjoy Geometry Dash Neon!"
    },
    {
      "id": 138,
      "url": "/games/\"Gun Master\"/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Gun  Master",
      "datasrc": "/games/Gun Master/icons/300x300.jpg",
      "logo": "/games/Gun Master/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Gun Master is a 2D shooting game that tests your reflexes and judgment. Each level pits you against multiple opponents that you must out-shoot to continue. Line up your shots carefully and don't miss, it might be your only chance!"
    },
    {
      "id": 139,
      "url": "/games/\"Hero Jump\"/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Hero  Jump",
      "datasrc": "/games/Hero Jump/icons/300x300.jpg",
      "logo": "/games/Hero Jump/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Hero Jump. Fly as far as possible across the sky jumping on the platforms. Collect coins, use spring jumps and the super jump power-up to get extra points!"
    },
    {
      "id": 140,
      "url": "/games/\"Jelly Doods\"/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Jelly  Doods",
      "datasrc": "/games/Jelly Doods/icons/300x300.jpg",
      "logo": "/games/Jelly Doods/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Jelly Doods is a fun puzzle game for both children and adults! Slide the jellies around the screen to combine all the matching colors. You only have so many moves to complete each puzzle, so make sure you plan accordingly!"
    },
    {
      "id": 141,
      "url": "/games/\"Knife Smash\"/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Knife  Smash",
      "datasrc": "/games/Knife Smash/icons/300x300.jpg",
      "logo": "/games/Knife Smash/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Knife throwing games have never been this fun and addictive with the Knife Master. In this free arcade game to throw the knife, you get to challenge your knife-throwing skills by hitting the target and avoid hitting the obstacles and of course the previous knife you’d thrown. So, if you are looking for an addictive arcade game to throw the knife, download Knife Master for free on your Android device and see how good you at throwing the knife to the target.\n"
    },
    {
      "id": 142,
      "url": "/games/\"Knife Up\"/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Knife  Up",
      "datasrc": "/games/Knife Up/icons/300x300.jpg",
      "logo": "/games/Knife Up/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "We need to control the timing of Feijian's throwing so that he can stand in the green area to score. Please be careful not to stay in one place for a long time. Let's try it now!"
    },
    {
      "id": 143,
      "url": "/games/\"Lost Island 3\"/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Lost  Island 3",
      "datasrc": "/games/Lost Island 3/icons/300x300.jpg",
      "logo": "/games/Lost Island 3/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Shoot the coloured marbles into the line in lost island 3 and try to make combinations of three or more marbles of the same colour. Aim and shoot colorfull marbles into the chain of marbles and connect 3 or more of the same marbles. Remove all marbles before they reach the exit. Click/tap on the shooter to change the color or the shooter. Shoot at the special bumpers for extra points."
    },
    {
      "id": 144,
      "url": "/games/\"Mao Mao Match Up!\"/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Mao  Mao  Match  Up!",
      "datasrc": "/games/Mao Mao Match Up!/icons/300x300.jpg",
      "logo": "/games/Mao Mao Match Up!/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Have you ever played match up games where you have to find similar cards with each other? In this game you have different modes for selection and you should memorize position of cards that are shown for a short period of time, then select two similar cards and get points for great memory."
    },
    {
      "id": 145,
      "url": "/games/\"Road Turn\"/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Road  Turn",
      "datasrc": "/games/Road Turn/icons/300x300.jpg",
      "logo": "/games/Road Turn/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "In Road Turn, a fun one-button car game, your job is to direct the traffic. Prevent traffic accidents by controlling when the cars can turn onto the highway."
    },
    {
      "id": 146,
      "url": "/games/SwingRobber/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Swing Robber",
      "datasrc": "/games/SwingRobber/icons/300x300.jpg",
      "logo": "/games/SwingRobber/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Swing Robber is on the move! Swing along the rooftops collecting money bags as you go. You decide how much rope to give Swing Robber so he can have a successful getaway! How far will you make it in this fun action game? Help this sneaky thief escape capture by swinging from building to building. Search for bags of gold for bonus points in this very fun physics based skill game. Become a famous robber by securing a high score."
    },
    {
      "id": 147,
      "url": "/games/\"Train Snake\"/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Train  Snake",
      "datasrc": "/games/Train Snake/icons/300x300.jpg",
      "logo": "/games/Train Snake/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "In Train Snake, you need to pick-up passengers and deliver them safely to their destinations without hitting any obstacle."
    },
    {
      "id": 148,
      "url": "/games/VikingHatFlip/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Viking Hat Flip",
      "datasrc": "/games/VikingHatFlip/icons/300x300.jpg",
      "logo": "/games/VikingHatFlip/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "Viking Hat Flip is a simple, but very hard casual game. It's fun, simple and easy, flip the viking's hat and keep it on his head. Also, there will be coins floating on top of his head, collect these coins for more points."
    },
    {
      "id": 149,
      "url": "/games/\"Color Crash\"/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Color  Crash",
      "datasrc": "/games/Color Crash/icons/300x300.jpg",
      "logo": "/games/Color Crash/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "\"Color Crash\" is an addictive arcade game where players must match colors to clear the screen and earn points. With fast-paced gameplay and colorful graphics, \"Color Crash\" is a fun and challenging game for players of all ages."
    },
    {
      "id": 150,
      "url": "/games/\"Cube Shift\"/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Cube  Shift",
      "datasrc": "/games/Cube Shift/icons/300x300.jpg",
      "logo": "/games/Cube Shift/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Cube Shift is a casual puzzle game where players must rotate cubes to create a path for a ball to reach the goal. With simple controls and addictive gameplay, Cube Shift is a great choice for casual gamers."
    },
    {
      "id": 151,
      "url": "/games/FallJumpRoll/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Fall Jump Roll",
      "datasrc": "/games/FallJumpRoll/icons/300x300.jpg",
      "logo": "/games/FallJumpRoll/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "\"Fall Jump Roll\" is a casual arcade game where players need to control a ball to jump and roll through obstacles. With simple controls and addictive gameplay, the game is suitable for players of all ages. There are many different levels in the game, each with increasing difficulty, challenging players' reaction speed and hand-eye coordination."
    },
    {
      "id": 152,
      "url": "/games/G-Switch/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " G- Switch",
      "datasrc": "/games/G-Switch/icons/300x300.jpg",
      "logo": "/games/G-Switch/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "G-Switch is a fast-paced and addictive platform game where players must navigate a series of obstacles by switching the direction of gravity. The goal is to reach the end of each level as quickly as possible while avoiding obstacles and collecting coins. With its simple controls and challenging gameplay, G-Switch is a great choice for gamers looking for a quick and fun challenge."
    },
    {
      "id": 153,
      "url": "/games/\"Hole Minator\"/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Hole  Minator",
      "datasrc": "/games/Hole Minator/icons/300x300.jpg",
      "logo": "/games/Hole Minator/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Eat and fill your color hole through black hole in hole game 3D. Do not pull other colors in the giant hole in black hole game."
    },
    {
      "id": 154,
      "url": "/games/RollyVortex/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Rolly Vortex",
      "datasrc": "/games/RollyVortex/icons/300x300.jpg",
      "logo": "/games/RollyVortex/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Rolly Vortex is an addictive casual game where you can run through nasty obstacles. By tapping and swiping your finger, the rolling of your ball is controlled to pass through the obstacles and collect the rubies. Playing as long as possible to earn maximum points. It shows that unrolling the ball is as important as rolling the ball in this game."
    },
    {
      "id": 155,
      "url": "/games/\"Skateboard Surfers\"/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Skateboard  Surfers",
      "datasrc": "/games/Skateboard Surfers/icons/300x300.jpg",
      "logo": "/games/Skateboard Surfers/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Become the coolest skateboard surfer in this game and collect all coins on your way. Dodge obstacles and use terrain to increase the amount of coins. Upgrade your character and purchase new skates to have even more fun. Skate can be lost after hitting obstacles, so you have to run and catch coins on your feet."
    },
    {
      "id": 156,
      "url": "/games/\"Soccer Sprint\"/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Soccer  Sprint",
      "datasrc": "/games/Soccer Sprint/icons/300x300.jpg",
      "logo": "/games/Soccer Sprint/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Soccer Sprint is a fun soccer-themed running and jumping skills game! Collect coins as you race through the field. Duck, dodge and leap over the obstacles in your way. How long can you stay in the game?"
    },
    {
      "id": 157,
      "url": "/games/VillageCraft/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Village Craft",
      "datasrc": "/games/VillageCraft/icons/300x300.jpg",
      "logo": "/games/VillageCraft/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 5,
      "synopsis": "This is a free creative survival exploration sandbox game. A wisp of smoke rises from the small village in the dusk. The village is surrounded by green mountains and clear water. The hazy moonlight enveloped the fields and villages, making them look extremely peaceful."
    },
    {
      "id": 158,
      "url": "/games/VillageBuilder/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Village Builder",
      "datasrc": "/games/VillageBuilder/icons/300x300.jpg",
      "logo": "/games/VillageBuilder/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4.5,
      "synopsis": "Game Content and Highlights Introduction for Village Builder: In Village Builder, players take on the role of a village leader and must build and manage their own village. The game features a simple and addictive gameplay that allows players to build and expand their village, collect resources, and interact with villagers. One of the highlights of Village Builder is its beautiful graphics and immersive sound effects. The game world is detailed and realistic, creating a immersive experience for players. With its addictive gameplay and beautiful graphics, Village Builder is sure to provide hours of entertainment for players of all ages."
    },
    {
      "id": 159,
      "url": "/games/TopChefHero2/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Top Chef Hero2",
      "datasrc": "/games/TopChefHero2/icons/300x300.jpg",
      "logo": "/games/TopChefHero2/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "Top Chef Hero 2 is a time-management game where players must run a restaurant and serve customers. Players must cook and serve dishes quickly to earn money and progress through the levels. The game features multiple restaurants and challenges, as well as the ability to upgrade your equipment and hire staff. With its addictive gameplay and challenging levels, Top Chef Hero 2 is a fun and engaging game for all ages."
    },
    {
      "id": 160,
      "url": "/games/StickMerge/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Stick Merge",
      "datasrc": "/games/StickMerge/icons/300x300.jpg",
      "logo": "/games/StickMerge/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Shooting game is a genre of video game where the player uses a weapon to shoot at targets or enemies. The goal is usually to eliminate all enemies or complete a mission. Shooting games can be played solo or with others online. They offer a variety of weapons and levels to keep the player engaged."
    },
    {
      "id": 161,
      "url": "/games/SpaceMerge/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Space Merge",
      "datasrc": "/games/SpaceMerge/icons/300x300.jpg",
      "logo": "/games/SpaceMerge/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "SpaceMerge is a classic merger and upgrade game that is fun and entertaining and is one of YIGAMES 'selected recommended games"
    },
    {
      "id": 162,
      "url": "/games/Misland/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Misland",
      "datasrc": "/games/Misland/icons/300x300.jpg",
      "logo": "/games/Misland/icons/300x300.jpg",
      "tag": "hot",
      "rating": 3.5,
      "synopsis": "Misland is a placement/management game that allows you to turn a desert island into a thriving paradise! Start picking apples from the tree with bear hands and upgrade your skills and tools one by one! This island is full of resources waiting to be discovered. By trading resources with ships, your wealth will grow. Once you have enough resources, you'll have a team of helpers to do tasks like apple harvesting, tree cutting, and quarrying! Watch out for invading monsters trying to steal your resources; You need to wield your sword to protect your island. Are you ready to oversee the transformation of the entire island?"
    },
    {
      "id": 163,
      "url": "/games/MergeTycoon/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Merge Tycoon",
      "datasrc": "/games/MergeTycoon/icons/300x300.jpg",
      "logo": "/games/MergeTycoon/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Merge Tycoon is a merge game where you must merge identical items to create new ones. The game features multiple levels and challenges, as well as power-ups and bonuses to help you along the way. With its addictive gameplay and colorful graphics, Merge Tycoon is a fun and challenging game for all ages."
    },
    {
      "id": 164,
      "url": "/games/MergeCyberRacers/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Merge Cyber Racers",
      "datasrc": "/games/MergeCyberRacers/icons/300x300.jpg",
      "logo": "/games/MergeCyberRacers/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4.5,
      "synopsis": "Merge Cyber Racers is a casual game that combines racing and merging elements. Players need to merge different cyber racers to unlock new racers and tracks. The game features simple controls and colorful graphics, making it easy and fun to play for all ages."
    },
    {
      "id": 165,
      "url": "/games/LumberRun/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Lumber Run",
      "datasrc": "/games/LumberRun/icons/300x300.jpg",
      "logo": "/games/LumberRun/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Welcome to Lumber Run! Chop the trees, cut the wood and run cross the river now! Axe down trees and convert them into wooden planks to run cross the river. The further you go the more expensive trees you axe. First one will win the level."
    },
    {
      "id": 166,
      "url": "/games/LumberArmy/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Lumber Army",
      "datasrc": "/games/LumberArmy/icons/300x300.jpg",
      "logo": "/games/LumberArmy/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "In the game, the player will play the role of the commander, send your most powerful heroes to obtain supplies together, continuously expand the size of the army, find the enemy's base camp, and destroy it! Let the world know how great you are!"
    },
    {
      "id": 167,
      "url": "/games/Lookyourloot/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Lookyourloot",
      "datasrc": "/games/Lookyourloot/icons/300x300.jpg",
      "logo": "/games/Lookyourloot/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Look, Your Loot is a placement card game with different cards and different characters and skills, which is very interesting. Come and try it"
    },
    {
      "id": 168,
      "url": "/games/IdleGoldMiner/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Idle Gold Miner",
      "datasrc": "/games/IdleGoldMiner/icons/300x300.jpg",
      "logo": "/games/IdleGoldMiner/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 5,
      "synopsis": "In Place the Gold Miner, you will be the manager of a brand new gold mine! You need to invest your money wisely to keep your mine running as efficiently and profitably as possible. You can invest in your employees to make sure they're working as fast as possible, and hire managers to automate tasks for you and keep an eye on your employees. Spend your money wisely and watch your company grow! Can you be a gold miner?"
    },
    {
      "id": 169,
      "url": "/games/HappyCups/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Happy Cups",
      "datasrc": "/games/HappyCups/icons/300x300.jpg",
      "logo": "/games/HappyCups/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Are you good at solving challenging puzzles in physics puzzle games? Do you want to test your abilities through exciting new level drawing games?"
    },
    {
      "id": 170,
      "url": "/games/FantasyMerger/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Fantasy Merger",
      "datasrc": "/games/FantasyMerger/icons/300x300.jpg",
      "logo": "/games/FantasyMerger/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "fantasy merger is a classic merger and upgrade game that is fun and entertaining and is one of YIGAMES 'selected recommended games"
    },
    {
      "id": 171,
      "url": "/games/Catpad/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Catpad",
      "datasrc": "/games/Catpad/icons/300x300.jpg",
      "logo": "/games/Catpad/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "In Catpad, you play as a cat! As a cat, you can do normal cat things; You can build a tower out of boxes, play with memories, and sometimes even drive a car at high speed. When you play, shiny balls of energy will appear. Hitting enough of these balls will put your cat into fever mode! In this mode, your cat will go a little crazy and start scoring lots of points. This can help you create new high scores and get new achievements. By scoring high, you will unlock new items to decorate your cat's home! There are more than 6 games for you to master. Would you and your cat make the perfect duo?"
    },
    {
      "id": 172,
      "url": "/games/BattleshipsArmada/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Battleships Armada",
      "datasrc": "/games/BattleshipsArmada/icons/300x300.jpg",
      "logo": "/games/BattleshipsArmada/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Battleships Armada is a classic naval battle strategy game. Players need to place their own ships on the board and guess the location of the opponent's ships to destroy them. The game features simple rules and addictive gameplay, making it suitable for players of all ages."
    },
    {
      "id": 173,
      "url": "/games/CandyPig/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Candy Pig",
      "datasrc": "/games/CandyPig/icons/300x300.jpg",
      "logo": "/games/CandyPig/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "The pig was not careful and ate a devil fruit! and then he lost his feet but with a stretch of his arm, he can reach a sufficient length to move. it is so amazing! enjoy helping him to collect the sweet candies! you can tap or click the point of wall to move."
    },
    {
      "id": 174,
      "url": "/games/CannonStrike/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Cannon Strike",
      "datasrc": "/games/CannonStrike/icons/300x300.jpg",
      "logo": "/games/CannonStrike/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "CannonStrike is a simple and fun psychological shooting game. When all the colored balls hit the target, shoot the ball and have more fun. At the corner of the challenge there are trucks waiting for candy cannonballs. You can choose many beautiful colored balls."
    },
    {
      "id": 175,
      "url": "/games/CastleEscapePlan/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Castle Escape Plan",
      "datasrc": "/games/CastleEscapePlan/icons/300x300.jpg",
      "logo": "/games/CastleEscapePlan/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "There are many traps in the castle, and the guarding soldiers are aggressive, protecting Jack, and letting him escape by combining different passage rooms. By the way, it is easy to get some gems."
    },
    {
      "id": 176,
      "url": "/games/CityConnect2/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " City Connect2",
      "datasrc": "/games/CityConnect2/icons/300x300.jpg",
      "logo": "/games/CityConnect2/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "City Connect 2 is a fun puzzle game with a unique twist – you must connect all buildings and roads together in your small city by rotating a series of tiles. The game was 6 different difficulty levels ranging from very easy to extreme and each difficulty has 30 different challenges. You must start with the yellow trimmed tile and work your way across the level to join the roads and buildings together."
    },
    {
      "id": 177,
      "url": "/games/ColorFill/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Color Fill",
      "datasrc": "/games/ColorFill/icons/300x300.jpg",
      "logo": "/games/ColorFill/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Color Fill is fun addictive puzzle game. You must attempt to fill all the empty block with color. You must plan your moves carefully and think about how you fill the blocks. Use mouse to play the game."
    },
    {
      "id": 178,
      "url": "/games/ConnectTheRoads/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Connect The Roads",
      "datasrc": "/games/ConnectTheRoads/icons/300x300.jpg",
      "logo": "/games/ConnectTheRoads/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Move the road tiles to complete the road. You need to get to work. 24 challenging levels guaranteed to twist your brain!"
    },
    {
      "id": 179,
      "url": "/games/CrazyZoo/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Crazy Zoo",
      "datasrc": "/games/CrazyZoo/icons/300x300.jpg",
      "logo": "/games/CrazyZoo/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Check out this retro puzzle game. Can you cover each level in one particular color? Do your best to match everything up. You are able to click different colors of this beautiful puzzle in an attempt to make it all a single, solid color. Each level is a work of art, looking beautiful before you result in making it solid."
    },
    {
      "id": 180,
      "url": "/games/DragonLand/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Dragon Land",
      "datasrc": "/games/DragonLand/icons/300x300.jpg",
      "logo": "/games/DragonLand/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Some annoying knights are trying to steal the dragon's treasure? Let's teach them a lesson they won's forget!"
    },
    {
      "id": 181,
      "url": "/games/DropMe!/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Drop Me!",
      "datasrc": "/games/DropMe!/icons/300x300.jpg",
      "logo": "/games/DropMe!/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 3.5,
      "synopsis": "In this game you need to help these cute monsters to get their tubes. But there are so many obstacles! Simply click on a monster to burst the bubble and pick up all the berries. Be very careful!"
    },
    {
      "id": 182,
      "url": "/games/ElementBlocks/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Element Blocks",
      "datasrc": "/games/ElementBlocks/icons/300x300.jpg",
      "logo": "/games/ElementBlocks/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4.5,
      "synopsis": "Weather the elements in this crazy addictive puzzle game! Simply drag and drop the block shapes onto the grid in order to create vertical or horizontal lines and score as many points as possible. Only full lines will be destroyed, so plan ahead and keep an eye on the available pieces. The game is over if there's no space left on the grid to place a block. Collect stars to buy power ups, complete achievements and try to remove several lines at once to earn additional points!"
    },
    {
      "id": 183,
      "url": "/games/Flou/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Flou",
      "datasrc": "/games/Flou/icons/300x300.jpg",
      "logo": "/games/Flou/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Flou is very simple and addictive puzzle game. Swipe to cover all the entire board. To ace the levels , you should be able to pairs the diamonds with similar color. Hundreds of levels ( and more to come ) ranged from small board to large board. Relaxing and challenging in the same time. Beware to be hooked with the uniqueness of the levels ."
    },
    {
      "id": 184,
      "url": "/games/FrogRush/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Frog Rush",
      "datasrc": "/games/FrogRush/icons/300x300.jpg",
      "logo": "/games/FrogRush/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "You are an elite scientist working at a secret lab! It wasn't your fault that the spill happened and contaminated the local lake with toxic chemicals, and made all the frogs into killer amphibians! OK maybe it was but we all have our off days. But now you need to solve the problem and DESTROY ALL FROGS. You can do this by drip feeding the frogs some precious \"Chemical K\". The frogs love this and grow larger with each drop until fully primed and \"SPLURGE!\" they explode shooting lethal frog blood all over the place. Any frog hit, if primed, will explode too so you need to ensure the perfect chain reaction using the tiny amount of Chemical K you have available."
    },
    {
      "id": 185,
      "url": "/games/GetItFilled2/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Get It Filled2",
      "datasrc": "/games/GetItFilled2/icons/300x300.jpg",
      "logo": "/games/GetItFilled2/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Your goal is to fill every space and reach the X. Click and drag the snake to move it around. You can't cross your own path."
    },
    {
      "id": 186,
      "url": "/games/HeartBox/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Heart Box",
      "datasrc": "/games/HeartBox/icons/300x300.jpg",
      "logo": "/games/HeartBox/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Heart box is a puzzle game with many levels and tricks. The goal is to get the smiley cube inside the red tray either by making the cube fall into it or the other way around. The level starts out easy, but it gets a lot more creative and difficult. Later levels will introduce cool contractions."
    },
    {
      "id": 187,
      "url": "/games/JewelCurse/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Jewel Curse",
      "datasrc": "/games/JewelCurse/icons/300x300.jpg",
      "logo": "/games/JewelCurse/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Slide and match the 3 relics with the same color to create gold squares on the tiles. in this cool match 3 game, you will have to slide lines or columns in order to align 3 identical symbols and to remove them from the grid. change all boxes backgrounds to unlock the next level. have fun!"
    },
    {
      "id": 188,
      "url": "/games/Linebright/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Linebright",
      "datasrc": "/games/Linebright/icons/300x300.jpg",
      "logo": "/games/Linebright/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Linebright is beautiful and logic, you need to use your brain to solve many problems about electric and physics. In this game you need to solve puzzle, avoid obstacles and collect crystal to complete. Have fun!"
    },
    {
      "id": 189,
      "url": "/games/\"Love Pins\"/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Love  Pins",
      "datasrc": "/games/Love Pins/icons/300x300.jpg",
      "logo": "/games/Love Pins/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "A simple puzzle game! Remove the pins in the correct order. Bring the boy and the girl together. It gets harder as you progress through the stages."
    },
    {
      "id": 190,
      "url": "/games/makewords/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": "Makewords",
      "datasrc": "/games/makewords/icons/300x300.jpg",
      "logo": "/games/makewords/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Make Words is a word game, one of the best brain teasing addictive word games in the market. The goal of the game is to make as many words as you can from given 7 letters . If you find all words you will get bonus."
    },
    {
      "id": 191,
      "url": "/games/MatchTerror/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Match Terror",
      "datasrc": "/games/MatchTerror/icons/300x300.jpg",
      "logo": "/games/MatchTerror/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "Match Terror is a Halloween combination game where you have to eliminate zombies, werewolves and aliens to reach your goals and levels. To play this free Match 3 game , use your mouse to eliminate groups of blocks made up of a minimum of three identical elements . You will need to reach the stated goals displayed at the top of your screen with the number of moves allocated , and not one more! You can create bombsas soon as you perform a match 5 or 6, and jewels from groups of 7 monsters eliminated. Collect these bonuses when they appear on the screen and use them when you're in trouble. The game has 100 levels with increasing difficulty."
    },
    {
      "id": 192,
      "url": "/games/MergeFish/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Merge Fish",
      "datasrc": "/games/MergeFish/icons/300x300.jpg",
      "logo": "/games/MergeFish/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Merge Fish! is a game designed to help you relax. Starting with an empty aquarium, you can create your own ocean world by merging small fish to get new and better ones. Exotic fish are waiting to be discovered, and lucky jellyfish will appear with amazing gifts. The process of filling the aquarium is exciting and addictive. Start your exploration of the ocean world now."
    },
    {
      "id": 193,
      "url": "/games/Monstersboom!/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Monstersboom!",
      "datasrc": "/games/Monstersboom!/icons/300x300.jpg",
      "logo": "/games/Monstersboom!/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4,
      "synopsis": "Monsters fill the pattern and you have two moves to clear them."
    },
    {
      "id": 194,
      "url": "/games/OneLiner/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " One Liner",
      "datasrc": "/games/OneLiner/icons/300x300.jpg",
      "logo": "/games/OneLiner/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Draw one single line, without ever lifting your finger or mouse. How many levels can you complete?Deceptively simple, yet profoundly deep game. Features:- Interactive tutorial- Over 120 challenging levels to keep you occupied- Upbeat, rhythmic theme- How difficult can this be? Just Draw 1 Line! Draw one single line, without ever lifting your finger or mouse."
    },
    {
      "id": 195,
      "url": "/games/PacktheBag/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Packthe Bag",
      "datasrc": "/games/PacktheBag/icons/300x300.jpg",
      "logo": "/games/PacktheBag/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Pack your suitcase and make sure that everything fits in perfectly in th unique puzzle game Pack the Bag!"
    },
    {
      "id": 196,
      "url": "/games/PackTheGraves/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Pack The Graves",
      "datasrc": "/games/PackTheGraves/icons/300x300.jpg",
      "logo": "/games/PackTheGraves/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Move around with the arrow keys and push all the monsters back into their graves. If you get stuck, press the restart button at the top of the screen."
    },
    {
      "id": 197,
      "url": "/games/Powerblocks/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Powerblocks",
      "datasrc": "/games/Powerblocks/icons/300x300.jpg",
      "logo": "/games/Powerblocks/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Drag and drop the shapes onto the board so that there are no spaces left. Can you beat all 60 levels in this very fun puzzle game? There are 5 awards to earn, so make sure to sign in before playing."
    },
    {
      "id": 198,
      "url": "/games/PuckHero/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Puck Hero",
      "datasrc": "/games/PuckHero/icons/300x300.jpg",
      "logo": "/games/PuckHero/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Puck Hero is an arcade puzzle online game which it is made from 3D game art animation. You need to control a puck and move it to the hole on a brick platform. Before the sign on the hole turns to a green tick, you are able to bounce all the black walls to make the puck closed to the hole. But as long as you saw the green tick on the hole, you have to move the puck into the hole in one chance, or less you will lose! Click to play online now!!!!"
    },
    {
      "id": 199,
      "url": "/games/RopeHelp/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Rope Help",
      "datasrc": "/games/RopeHelp/icons/300x300.jpg",
      "logo": "/games/RopeHelp/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Rope Help is an online puzzle game where you’ll need to connect different destinations and thus move everyone from point A to point B. This may sound simple enough, but it won’t be easy. The first level will be fairly simple, but you’ll soon have to start thinking about the direction that you’ll move your rope. If you come up with a method where you get the people to their designated spot, you win. You can buy new skins in the store. How many levels will you manage to complete?"
    },
    {
      "id": 200,
      "url": "/games/Sokoban/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Sokoban",
      "datasrc": "/games/Sokoban/icons/300x300.jpg",
      "logo": "/games/Sokoban/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4,
      "synopsis": "The objective of this game is to push the boxes to the designated locations/goals. Once all goals have boxes the level has been completed. In order to move the player, you have to swipe up/down/left/right to move in the respective location."
    },
    {
      "id": 201,
      "url": "/games/SokobanUnited/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Sokoban United",
      "datasrc": "/games/SokobanUnited/icons/300x300.jpg",
      "logo": "/games/SokobanUnited/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Sokoban United is a 3D Sokoban puzzle game in which you need to push 3D boxes to pass each level. You can only push the box and not pull the box. So think ahead of every move you make. Each Sokoban puzzle is solved when all boxes are at the target locations. Your goal is to push boxes to storage locations. You can push only one box at a time"
    },
    {
      "id": 202,
      "url": "/games/SwitchWaysDimensions/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Switch Ways Dimensions",
      "datasrc": "/games/SwitchWaysDimensions/icons/300x300.jpg",
      "logo": "/games/SwitchWaysDimensions/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Click on a tile, then click on another tile on the same plane to switch their places. Keep switching tiles until all endpoints of the same color are connected."
    },
    {
      "id": 203,
      "url": "/games/TruckLoader5/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Truck Loader5",
      "datasrc": "/games/TruckLoader5/icons/300x300.jpg",
      "logo": "/games/TruckLoader5/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "In Truck Loader 5 you have to load the cargo onto the truck that is waiting to depart! This edition brings you more challenging adventures. You need to use your creativity to complete the levels."
    },
    {
      "id": 204,
      "url": "/games/UnblockThat/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Unblock That",
      "datasrc": "/games/UnblockThat/icons/300x300.jpg",
      "logo": "/games/UnblockThat/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Unblock That is a simple and addictive puzzle game. The goal is to unblock the red block out of the board by sliding the other blocks out of the way, unblock it with the minimal moves."
    },
    {
      "id": 205,
      "url": "/games/BikeManiac/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Bike Maniac",
      "datasrc": "/games/BikeManiac/icons/300x300.jpg",
      "logo": "/games/BikeManiac/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "\"BikeManiac\" is an exciting motorcycle racing game that offers players the thrill of high-speed competition. With multiple tracks and challenging opponents, players can show off their skills and compete for the top spot. The game features realistic physics and stunning graphics, providing an immersive racing experience."
    },
    {
      "id": 206,
      "url": "/games/\"Blumgi Rocket\"/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Blumgi  Rocket",
      "datasrc": "/games/Blumgi Rocket/icons/300x300.jpg",
      "logo": "/games/Blumgi Rocket/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Game Content and Highlights Introduction for Blumgi Rocket: Blumgi Rocket is a fast-paced and exciting game that combines elements of racing and action. Players control a rocket and compete against other players in a race to the finish line. One of the highlights of Blumgi Rocket is its unique and challenging tracks. Players must navigate through obstacles and avoid hazards while trying to beat their opponents. With its fast-paced gameplay and challenging tracks, Blumgi Rocket is sure to provide hours of entertainment for players of all ages."
    },
    {
      "id": 207,
      "url": "/games/\"Freeway Fury 3\"/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Freeway  Fury 3",
      "datasrc": "/games/Freeway Fury 3/icons/300x300.jpg",
      "logo": "/games/Freeway Fury 3/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "In \"Freeway Fury 3\", players will experience high-speed racing on the freeway, avoiding obstacles and chasing opponents. With stunning graphics and exciting gameplay, this game will bring players an adrenaline-filled gaming experience. The highlight of this game is the variety of vehicles and tracks available, allowing players to choose their favorite cars and challenge different tracks. In addition, the game also features a rich soundtrack and realistic physics effects, making players feel like they are really on the freeway."
    },
    {
      "id": 208,
      "url": "/games/\"MotoX3M 6 Spooky Land\"/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Moto X3 M 6  Spooky  Land",
      "datasrc": "/games/MotoX3M 6 Spooky Land/icons/300x300.jpg",
      "logo": "/games/MotoX3M 6 Spooky Land/icons/300x300.jpg",
      "tag": "hot",
      "rating": 3.5,
      "synopsis": "\"Moto X3M Spooky Land\" is a thrilling dirt bike racing game set in a spooky Halloween-themed world. Players race through haunted forests, creepy caves, and eerie graveyards while avoiding obstacles and collecting coins."
    },
    {
      "id": 209,
      "url": "/games/\"Noob Drive\"/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Noob  Drive",
      "datasrc": "/games/Noob Drive/icons/300x300.jpg",
      "logo": "/games/Noob Drive/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Noob Drive is a racing game where players can drive different types of vehicles on the track and complete various challenges."
    },
    {
      "id": 210,
      "url": "/games/PaintAndRun/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Paint And Run",
      "datasrc": "/games/PaintAndRun/icons/300x300.jpg",
      "logo": "/games/PaintAndRun/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "paint and run is a very fun and exciting speed racing game, one of the best games recommended by yigames"
    },
    {
      "id": 211,
      "url": "/games/\"Race Madness\"/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Race  Madness",
      "datasrc": "/games/Race Madness/icons/300x300.jpg",
      "logo": "/games/Race Madness/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Race Madness is a racing game where players race against other players or the clock. The game features exciting gameplay and realistic graphics. It requires players to drive their cars through a variety of challenging tracks and try to win the race. Race Madness is a great way to experience the excitement of racing."
    },
    {
      "id": 212,
      "url": "/games/raceinferno2/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": "Raceinferno2",
      "datasrc": "/games/raceinferno2/icons/300x300.jpg",
      "logo": "/games/raceinferno2/icons/300x300.jpg",
      "tag": "hot",
      "rating": 5,
      "synopsis": "The game features exciting gameplay and realistic graphics. It requires players to drive their cars through a variety of challenging tracks and try to win the race. Race Madness is a great way to experience the excitement of racing."
    },
    {
      "id": 213,
      "url": "/games/\"Racing Monster Trucks\"/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Racing  Monster  Trucks",
      "datasrc": "/games/Racing Monster Trucks/icons/300x300.jpg",
      "logo": "/games/Racing Monster Trucks/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Racing Monster Trucks is an exciting racing game where you need to drive your monster truck through a dangerous track and compete against other drivers. With realistic physics and challenging tracks, the game offers a thrilling and addictive experience for players of all ages. Play Racing Monster Trucks now and become the champion!"
    },
    {
      "id": 214,
      "url": "/games/\"Retro Highway\"/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Retro  Highway",
      "datasrc": "/games/Retro Highway/icons/300x300.jpg",
      "logo": "/games/Retro Highway/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4,
      "synopsis": "retro highway is a very fun and exciting racing game, which is one of the recommended games by yigames"
    },
    {
      "id": 215,
      "url": "/games/\"Scurry Car\"/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Scurry  Car",
      "datasrc": "/games/Scurry Car/icons/300x300.jpg",
      "logo": "/games/Scurry Car/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Scurry Car is a racing game where players must race through a series of obstacle courses while avoiding obstacles and collecting coins. The game features a variety of cars, tracks, and power-ups to help players win."
    },
    {
      "id": 216,
      "url": "/games/\"Silly Sky\"/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Silly  Sky",
      "datasrc": "/games/Silly Sky/icons/300x300.jpg",
      "logo": "/games/Silly Sky/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Silly Sky is a management game where you play as an air traffic controller and guide a fleet of various aircraft from all directions. Marching aircraft to color-coded runways and helipads, you need to carefully arrange their movements and avoid any potential crashes! As you progress, you'll unlock a variety of maps, each presenting unique terrain and challenges - landing in a jungle storm, navigating overcast urban skies, dodged desert mountains, or dealing with tornado-filled farmland. Every game is a new adventure and the plane will surprise you, so buckle up and have the ultimate fun!"
    },
    {
      "id": 217,
      "url": "/games/\"Stock Car Hero\"/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Stock  Car  Hero",
      "datasrc": "/games/Stock Car Hero/icons/300x300.jpg",
      "logo": "/games/Stock Car Hero/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "\"Stock Car Hero\" is a racing game where you can compete against other players in stock car races. With its realistic physics and challenging tracks, \"Stock Car Hero\" is a great choice for racing fans looking for a thrilling and competitive gaming experience."
    },
    {
      "id": 218,
      "url": "/games/\"Superbike Hero\"/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Superbike  Hero",
      "datasrc": "/games/Superbike Hero/icons/300x300.jpg",
      "logo": "/games/Superbike Hero/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "\"Superbike Hero\" is an exciting motorcycle racing game where you can race against other players online. With its realistic physics and challenging tracks, \"Superbike Hero\" is a great choice for racing fans looking for a thrilling and competitive gaming experience."
    },
    {
      "id": 219,
      "url": "/games/CraftCommander/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Craft Commander",
      "datasrc": "/games/CraftCommander/icons/300x300.jpg",
      "logo": "/games/CraftCommander/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 3.5,
      "synopsis": "Craft Commander, it’s time to conquer the enemy’s last fortress! Fight and defend your polytopia as the war commander. Defeat the enemy’s army by crafting and building your warriors and army base. Capture the enemy’s flag. Protect the villagers and craftsman tribes. Block the invasion of the conqueror and enemy soldiers."
    },
    {
      "id": 220,
      "url": "/games/DoctorTeeth/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Doctor Teeth",
      "datasrc": "/games/DoctorTeeth/icons/300x300.jpg",
      "logo": "/games/DoctorTeeth/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "\"Doctor Teeth\" is a simulation game where players take on the role of a dentist and treat patients with various dental problems. The game features realistic tools and procedures, as well as educational information about oral hygiene."
    },
    {
      "id": 221,
      "url": "/games/ElliesSurpriseBirthdayParty/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Ellies Surprise Birthday Party",
      "datasrc": "/games/ElliesSurpriseBirthdayParty/icons/300x300.jpg",
      "logo": "/games/ElliesSurpriseBirthdayParty/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Ellie's Surprise Birthday Party is a party planning game where players help Ellie plan her birthday party. Players must choose a theme, decorations, food, and activities for the party. The game features multiple levels and challenges, as well as power-ups and rewards to help players plan the perfect party."
    },
    {
      "id": 222,
      "url": "/games/FireFighter/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Fire Fighter",
      "datasrc": "/games/FireFighter/icons/300x300.jpg",
      "logo": "/games/FireFighter/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Fire Idle is a single player firefighter simulator for mobile devices. Will you save your hometown from the fire? Can you take on the role of a rescuer for ordinary residents?"
    },
    {
      "id": 223,
      "url": "/games/IdleAntsPoki/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Idle Ants Poki",
      "datasrc": "/games/IdleAntsPoki/icons/300x300.jpg",
      "logo": "/games/IdleAntsPoki/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Content Introduction and Highlights of \"Idle Ants\" Game: In this addictive game, players get to manage their own ant colony and witness their growth. The ants will busily collect resources and build their nest, while the player can enjoy watching their hard work pay off. One of the highlights of \"Idle Ants\" is its charming and colorful graphics that bring the ant colony to life. Players can also unlock various upgrades and bonuses to enhance their colony's productivity and efficiency. With its simple and intuitive gameplay, \"Idle Ants\" is perfect for gamers of all ages and skill levels. Whether you have a few minutes to spare or want to spend hours immersed in the world of ants, this game will keep you entertained and engaged."
    },
    {
      "id": 224,
      "url": "/games/IdleMiningEmpire/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Idle Mining Empire",
      "datasrc": "/games/IdleMiningEmpire/icons/300x300.jpg",
      "logo": "/games/IdleMiningEmpire/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "Content Introduction and Highlights for the Attractive Idle Mining Empire Game (within 300 words): In the Idle Mining Empire game, players build and manage their own mining empire. They can extract various resources, upgrade their mines, and expand their empire. The game features idle gameplay, allowing players to earn resources even when offline. One of the highlights of the game is its addictive gameplay mechanics. Players can automate their mining processes and watch their empire grow and thrive. The game also offers challenging missions and events that keep players engaged and motivated. With itsIdle Mining Empire, players can enjoy the thrill of building a successful mining empire and become the ultimate mining tycoon."
    },
    {
      "id": 225,
      "url": "/games/IslandCorps/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Island Corps",
      "datasrc": "/games/IslandCorps/icons/300x300.jpg",
      "logo": "/games/IslandCorps/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "On a small island, young people go out to sea every day to form their own regiment. They are the freest people on the sea. They all have a grand dream, that is to build the best sea warship!"
    },
    {
      "id": 226,
      "url": "/games/KillerSnake/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Killer Snake",
      "datasrc": "/games/KillerSnake/icons/300x300.jpg",
      "logo": "/games/KillerSnake/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4.5,
      "synopsis": "\"Killer Snake\" is a classic arcade game where you control a snake and eat food to grow longer. The game features simple controls, challenging gameplay, and multiple levels of increasing difficulty."
    },
    {
      "id": 227,
      "url": "/games/LikeAKing!/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Like A King!",
      "datasrc": "/games/LikeAKing!/icons/300x300.jpg",
      "logo": "/games/LikeAKing!/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "\"Like a King\" is a strategy game where players build and manage their own kingdom. The game features resource management, city building, and battles with other players. Players need to make strategic decisions to expand their kingdom and become the most powerful ruler."
    },
    {
      "id": 228,
      "url": "/games/MeowfiaEvolution/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Meowfia Evolution",
      "datasrc": "/games/MeowfiaEvolution/icons/300x300.jpg",
      "logo": "/games/MeowfiaEvolution/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4.5,
      "synopsis": "Evolve your cats into mafia bosses in this super unique evolution style incremental game. Your cats start at the bottom of the crime family but can slowly evolve into famous cat crime bosses. Save cats from the paper bags and then drag two of the same cats together to evolve them. Purchase upgrades like poop scoops and fish delivery to reach the ultimate Godpurrer cat."
    },
    {
      "id": 229,
      "url": "/games/MikaPoki/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Mika Poki",
      "datasrc": "/games/MikaPoki/icons/300x300.jpg",
      "logo": "/games/MikaPoki/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "MikaPoki is a platformer game where you must help Mika collect candy while avoiding obstacles. With its colorful graphics and fun gameplay, \"Mikas Candy Adventure\" is a great choice for players of all ages looking for a sweet and addictive gaming experience."
    },
    {
      "id": 230,
      "url": "/games/SandwitchOnline/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " Sandwitch Online",
      "datasrc": "/games/SandwitchOnline/icons/300x300.jpg",
      "logo": "/games/SandwitchOnline/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4.5,
      "synopsis": "Sandwitch Online is a casual puzzle game where players must stack sandwiches to build the tallest tower. With simple controls and addictive gameplay, Sandwitch Online is a great choice for casual gamers."
    },
    {
      "id": 231,
      "url": "/games/ToyDefense/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Toy Defense",
      "datasrc": "/games/ToyDefense/icons/300x300.jpg",
      "logo": "/games/ToyDefense/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "It's game time, soldier! Want to have a fast and exciting tower defense battle? Toy Defense will satisfy you. Forget those castles and tribes-join the real modern battlefield, command powerful armored vehicles, hone your strategy skills, and become the ultimate battlefield commander!"
    },
    {
      "id": 232,
      "url": "/games/AmericanFootballChallenge/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " American Football Challenge",
      "datasrc": "/games/AmericanFootballChallenge/icons/300x300.jpg",
      "logo": "/games/AmericanFootballChallenge/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "\"American Football Challenge\" is an exciting sports game that lets you experience the thrill of American football. You can choose your favorite team and compete against other teams in intense matches. The game features realistic gameplay and graphics, making you feel like you're on the field. Whether you're a fan of football or just looking for a fun game, \"American Football Challenge\" is sure to keep you entertained."
    },
    {
      "id": 233,
      "url": "/games/Andy'sGolf/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " Andy's Golf",
      "datasrc": "/games/Andy'sGolf/icons/300x300.jpg",
      "logo": "/games/Andy'sGolf/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Andy is going to play some golf, but there is a challenge for him. Each level consists of multiple holes and you must complete it by using as less strokes as possible. Face all traps and obstacles of the map and try to show the best skill you can. Just Set the direction and release the button to see where it goes. A hole in one?!? Play this challenging golf game and try to clear the course with the fewest number of strokes. Can you overcome the various hazards and beat the par score?"
    },
    {
      "id": 234,
      "url": "/games/ArcadeGolf/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Arcade Golf",
      "datasrc": "/games/ArcadeGolf/icons/300x300.jpg",
      "logo": "/games/ArcadeGolf/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Arcade Golf is a HTML5 sport game. Play through the 10 holes of this minimal flat golf. Shoot the ball in all the holes with the least hits possible. Click and drag to take a shot. Drag further away to hit the ball harder. Tip: You can click and drag anywhere on the screen, not just behind the ball."
    },
    {
      "id": 235,
      "url": "/games/AthleticsHero/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Athletics Hero",
      "datasrc": "/games/AthleticsHero/icons/300x300.jpg",
      "logo": "/games/AthleticsHero/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Athletics Hero is an athletics game where players compete in a variety of events such as running, jumping, and throwing. Players can choose to play as one of several athletes and compete against other players or the computer. The game features realistic physics and graphics, as well as multiple game modes and difficulty levels."
    },
    {
      "id": 236,
      "url": "/games/ColdStorage/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Cold Storage",
      "datasrc": "/games/ColdStorage/icons/300x300.jpg",
      "logo": "/games/ColdStorage/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Cold Storage is a survival game where you must survive in a frozen environment by collecting resources and building a shelter. The game features multiple levels and challenges, as well as realistic survival mechanics and a immersive atmosphere. With its challenging gameplay and stunning graphics, Cold Storage is a great game for survival enthusiasts."
    },
    {
      "id": 237,
      "url": "/games/MTBHero/index.html",
      "category": "Puzzle",
      "key": "Puzzle",
      "title": " M T B Hero",
      "datasrc": "/games/MTBHero/icons/300x300.jpg",
      "logo": "/games/MTBHero/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "MTB Hero is a mountain biking game where players ride their bikes through various trails and obstacles. The game features multiple levels and challenges, as well as power-ups and upgrades to enhance the player's biking abilities. Players can compete against other players online for the highest score."
    },
    {
      "id": 238,
      "url": "/games/PocketHockeyPoki/index.html",
      "category": "Eliminate",
      "key": "Eliminate",
      "title": " Pocket Hockey Poki",
      "datasrc": "/games/PocketHockeyPoki/icons/300x300.jpg",
      "logo": "/games/PocketHockeyPoki/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "\"Pocket Hockey\" is a hockey simulation game where you can play as your favorite team and compete against other teams. With its realistic physics and simple controls, \"Pocket Hockey\" is a great choice for hockey fans looking for a quick and fun gaming experience."
    },
    {
      "id": 239,
      "url": "/games/PongGoal/index.html",
      "category": "Classic",
      "key": "Classic",
      "title": " Pong Goal",
      "datasrc": "/games/PongGoal/icons/300x300.jpg",
      "logo": "/games/PongGoal/icons/300x300.jpg",
      "tag": "hot",
      "rating": 3.5,
      "synopsis": "This game is very simple. All you have to do for win is move the beam on your side! Move beam along the line and prevent opponent from scoring goals. Reflect hits and make sure you score more goals for the win!"
    },
    {
      "id": 240,
      "url": "/games/SkateboardHero/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Skateboard Hero",
      "datasrc": "/games/SkateboardHero/icons/300x300.jpg",
      "logo": "/games/SkateboardHero/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Skateboard Hero is a skateboarding game where players perform tricks and stunts on a skateboard. Players must navigate through various levels while collecting coins and avoiding obstacles. The game features multiple skateboards and characters to choose from, as well as a variety of tricks and combos to perform."
    },
    {
      "id": 241,
      "url": "/games/SlalomHero/index.html",
      "category": "Racing",
      "key": "Racing",
      "title": " Slalom Hero",
      "datasrc": "/games/SlalomHero/icons/300x300.jpg",
      "logo": "/games/SlalomHero/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "Slalom Hero is a skiing game where players ski down a slope while avoiding obstacles and collecting coins. The game features multiple levels and challenges, as well as power-ups and upgrades to enhance the player's skiing abilities. Players can compete against other players online for the highest score."
    },
    {
      "id": 242,
      "url": "/games/SportMinibattlesbySharedDreams/index.html",
      "category": "Fighting",
      "key": "Fighting",
      "title": " Sport Minibattlesby Shared Dreams",
      "datasrc": "/games/SportMinibattlesbySharedDreams/icons/300x300.jpg",
      "logo": "/games/SportMinibattlesbySharedDreams/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Challenge the PC/PHONE or a friend to four different sports games. Become a master in these funny sports mini games as you battle against your opponent. Try to win each battle to prove to your challenger that you are the best. Play Tennis, Soccer, Basketball or Volleyball mini battles."
    },
    {
      "id": 243,
      "url": "/games/TennisHero/index.html",
      "category": "Simulated business",
      "key": "Simulated",
      "title": " Tennis Hero",
      "datasrc": "/games/TennisHero/icons/300x300.jpg",
      "logo": "/games/TennisHero/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Tennis Hero is a tennis game where players can play as their favorite tennis players and compete in tournaments. The game features realistic physics and graphics, as well as multiple game modes and difficulty levels. With its addictive gameplay and challenging opponents, Tennis Hero is a fun and exciting game for tennis fans."
    },
    {
      "id": 244,
      "url": "/games/TinyCricket/index.html",
      "category": "Tower Defense",
      "key": "Tower",
      "title": " Tiny Cricket",
      "datasrc": "/games/TinyCricket/icons/300x300.jpg",
      "logo": "/games/TinyCricket/icons/300x300.jpg",
      "rating": 5,
      "synopsis": "In this time, you will help Cricket Boy play from the lower leagues to the premier league. You will continue to play as a batsman and play against your opponents in real cricket matches! In order to hit the ball, you need to catch the best timing and tap the screen by your finger."
    },
    {
      "id": 245,
      "url": "/games/WorldCup18/index.html",
      "category": "Girls Games",
      "key": "Girls",
      "title": " World Cup18",
      "datasrc": "/games/WorldCup18/icons/300x300.jpg",
      "logo": "/games/WorldCup18/icons/300x300.jpg",
      "tag": "hot",
      "rating": 4,
      "synopsis": "Show other countries, who has the best team of soccer stars and win the tournament! In this one of the best sports games, your knowledge of football games is an invaluable asset, as players' individual skill levels, playstyles and moves are rendered in-game with meticulous attention to detail."
    },
    {
      "id": 246,
      "url": "/games/ClashOfVikings/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": " Clash Of Vikings",
      "datasrc": "/games/ClashOfVikings/icons/300x300.jpg",
      "logo": "/games/ClashOfVikings/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Command your Vikings and destroy the enemy's base in Clash of Vikings, a new HTML5 battle game! The base is guarded by two towers which you need to destroy. Plan your strategy carefully by placing troop in the right positions. To summon troops, you need to have enough elixir. In each battle, you can bring eight different troops. Make sure to customize your deck to match your strategy. You can play aggressively or defensively... It's up to you!"
    },
    {
      "id": 247,
      "url": "/games/daymeat/index.html",
      "category": "Parkour",
      "key": "Parkour",
      "title": "Daymeat",
      "datasrc": "/games/daymeat/icons/300x300.jpg",
      "logo": "/games/daymeat/icons/300x300.jpg",
      "rating": 3.5,
      "synopsis": "In a primitive tribe, you lead the people to expand, slowly grow, from the establishment of the tribe, to the creation of a kingdom, want to experience the fun of being a king? Come and try it!!"
    },
    {
      "id": 248,
      "url": "/games/DefendTheCastle/index.html",
      "category": "Adventure Games",
      "key": "Adventure",
      "title": " Defend The Castle",
      "datasrc": "/games/DefendTheCastle/icons/300x300.jpg",
      "logo": "/games/DefendTheCastle/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4,
      "synopsis": "Defend the Castle is a casual tower defense game where players must defend their castle from invading enemies. With simple controls and addictive gameplay, Defend the Castle is a great choice for casual gamers."
    },
    {
      "id": 249,
      "url": "/games/Gobdun/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Gobdun",
      "datasrc": "/games/Gobdun/icons/300x300.jpg",
      "logo": "/games/Gobdun/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 5,
      "synopsis": "Gobdun is a 3D grid-based dungeon crawling role-playing game where you will traverse a maze full of secrets, treasures and creatures. Use your sword to attack the dungeon dwellers, and when appropriate raise your shield to block and even super block their attacks. Your mission is to rise as high as you can and reach the top, but there are more powerful enemies and goblins waiting to attack you. Collect experience points, treasure chests, and even vending machines scattered throughout the maze to become stronger. If you want less challenge, use the \"Auto\" button so that the game will automatically take you where you are supposed to go. Don't forget to share Gobbleton with your friends and see who makes it to the top!"
    },
    {
      "id": 250,
      "url": "/games/MergeArena/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Merge Arena",
      "datasrc": "/games/MergeArena/icons/300x300.jpg",
      "logo": "/games/MergeArena/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "merge arena is a merged tower defense game, improve combat effectiveness by merging upgrades, defeat the enemy in the battle to capture the map, very interesting, come and try it"
    },
    {
      "id": 251,
      "url": "/games/MonsterTowerDefense/index.html",
      "category": "Board Games",
      "key": "Board",
      "title": " Monster Tower Defense",
      "datasrc": "/games/MonsterTowerDefense/icons/300x300.jpg",
      "logo": "/games/MonsterTowerDefense/icons/300x300.jpg",
      "rating": 4.5,
      "synopsis": "Place your monster towers on the field to defend against the invaders. As you collect energy by destroying the ball invaders, you can use it to purchase more and even better monsters. Don’t let the invaders reach your base!"
    },
    {
      "id": 252,
      "url": "/games/NanoWarCellsVSVirus/index.html",
      "category": "Mini Games",
      "key": "Mini",
      "title": " Nano War Cells V S Virus",
      "datasrc": "/games/NanoWarCellsVSVirus/icons/300x300.jpg",
      "logo": "/games/NanoWarCellsVSVirus/icons/300x300.jpg",
      "tag": "recommend",
      "rating": 4.5,
      "synopsis": "Nano War is a casual puzzle game, when the virus begins to invade, you need to learn to attack and defeat it, come and try it"
    },
    {
      "id": 253,
      "url": "/games/RusherCrusher1.0.0/index.html",
      "category": "Casual",
      "key": "Casual",
      "title": " Rusher Crusher1.0.0",
      "datasrc": "/games/RusherCrusher1.0.0/icons/300x300.jpg",
      "logo": "/games/RusherCrusher1.0.0/icons/300x300.jpg",
      "rating": 4,
      "synopsis": "Rusher Crusher is an arcade game in which you defeat pixel monsters using your car's guns and turrets. Your city is being invaded by a variety of giant pixel monsters that destroy everything in their path, and your job is to upgrade your weapons and attack speed to tear them down into pixels. You have 20 seconds in each level to destroy monsters, remember, it's really hard to defeat a monster. So get ready to die, then improve your car and try again with more powerful weapons. Make sure to shoot flying items on the screen to get a temporary attack boost. There are hundreds of monsters in Rusher Crusher waiting for you to discover and disintegrate!"
    }
  ]
}